import React from 'react';
import {Button, Col, Container, Row, Card, CardBody, PopoverHeader, PopoverBody, Popover, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress';
import {fetchSalesItemDataIfNeeded} from '../../redux/actions/SalesItemActions';
import {customer_insert, customer_update} from '../../redux/actions/CustomersActions';
import {ButtonToolbar} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import ReactQueryParams from 'react-query-params';
import * as TextManager from "../../modules/languages/TextManager";
import RadioButtonField from "../../components/RadioButton";
import Select from "../../components/Select";
import * as http from '../../modules/http';
import {Redirect} from 'react-router-dom';
import 'react-credit-cards/lib/styles.scss';
import Cards from 'react-credit-cards';
import NumberFormat from 'react-number-format';
import equal from 'deep-equal';
import ModalTrue from '../../components/ModalTrue';
import ModalTrue2 from '../../components/ModalTrue2';
import ModalTrueBig from '../../components/ModalTrueBig';
import ModalESim from '../../components/ModalESim';
import ModalHotCustomer from '../../components/ModalHotCustomer';
import * as environment from "../../modules/environment";
import {checkId} from "../../modules/common"
import ChatCard from '../../components/Chat/components/ChatCard'
import CheckBox from '../../components/CheckBox';
import moment from 'moment';
import classnames from 'classnames';
import Textarea from '../providers/components/PopoverTopProvider'
import {provider_deal_changed} from "../../redux/actions/ProvidersActions";
import validateEmail from '../../modules/validate';


// Internet
const bezekField = ["תשתית בלבד", "בנדל", "קו טלפון", "מכשיר", "אחר"];
const hotField = ["תשתית בלבד", "בנדל", "קו טלפון", "אחר"];
const allRestField = ["שו''ס", "ספק", "אחר"];

// TV
const tvFiled = ["טיוי בלבד", "טריפל", "אחר"];

const yesNo = [{label: 'כן'}, {label: 'לא'}];

const simOrSend = [
    {
        value: 0,
        label: "שליחות"
    },
    {
        value: 1,
        label: "סים"
    },
    {
        value: 2,
        label: 'eSim'
    }
];

class SalesItem extends ReactQueryParams {

    constructor(props) {
        super(props);
        let salesType = props.customer && props.customer.dealType ? props.customer.dealType : props.location.state.type;
        //this.state =  this.updateDataInState(props, salesType);

        this.state = {
            warning: '',
            error: false,
            saved: false,
            success: false,
            errorText: "",
            cardFocus: "",
            cardFocusPrev: "",
            cardValidWarning: "",
            comment: "",
            commentD: "",
            now_handle_by: 0,
            salesType: salesType,
            isImport: true,
            isDataToImport: false,
            showChangeProvider: false,
            wasProviderChanged: false,
            showChangeStore: false,
            tvInternetDealType: -1,
            formFields: this.updateDataInState(props, salesType),
            shouldDealReminderUpdate: 0,
            commentForDealReminder: 0,
            selfDeal: false,
            selfDealCheck: false,
            showImage: false,
            popoverOpen: -1,
            isPassportShow: false,
            activeTab: 0,
            isESimShow: false,
            isESimFiled: false,
            isShowAutoImages: false,
            isCheckHot: true,
            isHotCustomer: false
        };

        var webSocket;
        var messageInput;
    }

    updateDataInState = (props, salesType) => {
        return {
            customerName: (props.customer && props.customer.name) ? props.customer.name : "",
            customerId: (props.customer && props.customer.customerId) ? props.customer.customerId : "",
            id: (props.customer && props.customer.passport) ? props.customer.passport : "",
            address: (props.customer && props.customer.address) ? props.customer.address : "",
            city: (props.customer && props.customer.city) ? props.customer.city : undefined,
            cityName: (props.customer && props.customer.cityName) ? props.customer.cityName : "",
            street: (props.customer && props.customer.street) ? props.customer.street : undefined,
            streetName: (props.customer && props.customer.streetName) ? props.customer.streetName : "",
            number: (props.customer && props.customer.number) ? props.customer.number : "",
            flat: (props.customer && props.customer.flat) ? props.customer.flat : "",
            floor: (props.customer && props.customer.floor) ? props.customer.floor : "",
            providerId: (props.customer && props.customer.providerId) ? props.customer.providerId : "",
            providerName: (props.customer && props.customer.providerName) ? props.customer.providerName : "",
            storeId: (props.customer && props.customer.storeId) ? props.customer.storeId : 0,
            storeName: (props.customer && props.customer.storeName) ? props.customer.storeName : "",
            numOfLines: (props.customer && props.customer.numOfLines) ? props.customer.numOfLines : 0,
            lines: salesType === 1 ? (props.customer && props.customer.lines) ? props.customer.lines : [
                {
                    deal: {
                        text: "",
                        amount: "0"
                    },
                    customerNumber: "",
                    simNumber: "",
                    status: 3,
                    secondStatus: 0,
                    notes: '',
                    question: 0,
                    handleName: 0,
                    isNewNumber: 0,
                    tempSimNumber: ""
                }
            ] : undefined,
            tv: salesType === 2 ? (props.customer && props.customer.tv) ? props.customer.tv : {
                mail: "",
                numberOfConvertors: "",
                executorDetails: "",
                deal: "",
                router: ""
            } : undefined,
            // mail: String, deal: String, routerCost: Int, shipmentCost: Int, executorDetails: String
            internet: salesType === 3 ? (props.customer && props.customer.internet) ? props.customer.internet : {
                mail: "",
                deal: "",
                routerCost: "",
                shipmentCost: "",
                executorDetails: ""
            } : undefined,
            status: (props.customer && props.customer.status) ? props.customer.status : 1,
            secondStatus: (props.customer && props.customer.secondStatus) ? props.customer.secondStatus : 1,
            paymentMethod: (props.customer && props.customer.paymentMethod) ? props.customer.paymentMethod : "credit",
            paymentDetails: (props.customer && props.customer.paymentDetails) ? props.customer.paymentDetails : {
                cardType: "unknown",
                cardNumber: "",
                cardNumberImport: "",
                validationDate: "",
                cvv: "",
                cvvImport: "",
                bank: "",
                bankAccountBranch: "",
                bankAccountNumber: ""
            },
            day: (props.customer && props.customer.day) ? props.customer.day : "",
            manageDay: (props.customer && props.customer.manageDay) ? props.customer.manageDay : "",
            updateDay: (props.customer && props.customer.updateDay) ? props.customer.updateDay : "",
            dealType: salesType,
            careBy: (props.customer && props.customer.careBy) ? props.customer.careBy : 0,
            lastUpdateBy: (props.customer && props.customer.lastUpdateBy) ? props.customer.lastUpdateBy : 0,
            chat: (props.customer && props.customer.chat) ? props.customer.chat : [],
            contact: (props.customer && props.customer.contact) ? props.customer.contact : '',
            mail: (props.customer && props.customer.mail) ? props.customer.mail : '',
            is_duplicate: (props.customer && props.customer.is_duplicate) ? props.customer.is_duplicate : 0,
            given_number: (props.customer && props.customer.given_number) ? props.customer.given_number : '',
            admin_comment: (props.customer && props.customer.admin_comment) ? props.customer.admin_comment : '',
            as_new: (props.customer && props.customer.as_new) ? props.customer.as_new : 0,
            deal_reminder: (props.customer && props.customer.deal_reminder) ? props.customer.deal_reminder : 0,
            external_id: (props.customer && props.customer.external_id) ? props.customer.external_id : 0,
            chatDealReminder: (props.customer && props.customer.chatDealReminder) ? props.customer.chatDealReminder : [],
            deal_image: (props.customer && props.customer.deal_image) ? props.customer.deal_image : 0,
            isAuto: (props.customer && props.customer.isAuto) ? props.customer.isAuto : [],
            autoMes: (props.customer && props.customer.autoMes) ? props.customer.autoMes : "",
            autoDealDetail: (props.customer && props.customer.autoDealDetail) ? props.customer.autoDealDetail : [],
            uniqueId: (props.customer && props.customer.uniqueId) ? props.customer.uniqueId : '',
            eSimDetail: (props.customer && props.customer.eSimDetail) ? props.customer.eSimDetail : {}
        };
    };

    componentDidMount() {

        this.props.dispatch(fetchSalesItemDataIfNeeded(this.props.match.params.id ? this.props.match.params.id :
            this.props.customer.providerId ? this.props.customer.providerId : 0)).then(response => {

            if (response) {
                this.setState({
                    formFields: {
                        ...this.state.formFields, lines: this.state.formFields.lines && this.state.formFields.lines
                            .map((l, index) => {
                                return {
                                    customerNumber: l.customerNumber,
                                    simNumber: l.simNumber,
                                    isTempNumber: l.isTempNumber,
                                    tempSimNumber: l.tempSimNumber,
                                    deal: (l.deal && Object.getOwnPropertyNames(l.deal).length > 0) ? l.deal : this.props.dealsList[0],
                                    status: l.status,
                                    secondStatus: l.secondStatus,
                                    notes: l.notes,
                                    question: l.question === undefined ? 0 : l.question,
                                    handleName: l.handleName === undefined ? 0 : l.handleName,
                                    isNewNumber: l.isNewNumber === undefined ? 0 : l.isNewNumber,
                                    uniqueId: l.uniqueId,
                                    isSimOrSend: l.isSimOrSend,
                                    orderNum: l.orderNum
                                }
                            })
                    }
                }, () => {
                });
            }
        });

        if (this.props.customer) {
            http.postToServer(
                'customers/get_customer?customerId=' + this.props.customer.id + '&storeId=' + this.props.userData.data.id,
                {},
                (response) => {
                    //console.log(response.data);
                    this.setState({now_handle_by: response.data[0].now_handle_by})
                },
                (response) => {
                    console.log('error ' + response.data);
                    //this.setState({errorText: response.data.message})
                }
            );
        }

        if (this.props.userData && this.props.userData.data) {
            this.webSocket = new WebSocket(environment.getServerBasePath().replace("http", "ws") + "/ws?clientId=" + this.props.userData.data.id);
            this.webSocket.onopen = this.onOpenWebSocket;
            this.webSocket.onclose = this.onCloseWebSocket;
            this.webSocket.onmessage = this.onMessageWebSocket;
            this.webSocket.onerror = this.onErrorWebSocket;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!equal(this.props, nextProps)) {
            let formFields = this.state.formFields;
            formFields.paymentDetails = (nextProps.customer && nextProps.customer.paymentDetails) ? nextProps.customer.paymentDetails : {
                cardType: "unknown",
                cardNumber: "",
                validationDate: "",
                cvv: "",
                bank: "",
                bankAccountBranch: "",
                bankAccountNumber: ""
            };
            this.setState({formFields: formFields})
        }
    }

    onOpenWebSocket = (event) => {
        //console.log("CONNECTED");

        /*let jsonMessage = {
            message: "Bingo!!!"
        };

        if(this.webSocket.readyState === WebSocket.OPEN) {
            this.webSocket.send(JSON.stringify(jsonMessage));
        } else {
            console.log("Could not send data. Websocket is not open.");
        }*/

    };

    onCloseWebSocket = (event) => {
        //console.log("DISCONNECTED");
    };

    onErrorWebSocket = (event) => {
        console.log("ERROR: " + event.data);
        console.log("ERROR: " + JSON.stringify(event));
    };

    onMessageWebSocket = (event) => {
        let receivedData = JSON.parse(event.data);

        if (receivedData.body === "REFRESH") {
            console.log("Make refresh");
            http.postToServer(
                'customers/get_customer?customerId=' + this.props.customer.id + '&storeId=' + this.props.userData.data.id,
                {},
                (response) => {
                    //console.log("Here");
                    //this.setState({now_handle_by: response.data[0].now_handle_by})
                    let obj = {customer: response.data[0]};

                    // merge chat
                    obj.customer.chat = Array.prototype.push.apply(obj.customer.chat, this.state.formFields.chat);
                    this.setState({formFields: this.updateDataInState(obj, this.state.salesType)});

                    // merge chat deal reminder
                    obj.customer.chatDealReminder = Array.prototype.push.apply(obj.customer.chatDealReminder, this.state.formFields.chatDealReminder);
                    this.setState({formFields: this.updateDataInState(obj, this.state.salesType)});
                },
                (response) => {
                    console.log('error ' + response);
                    //this.setState({errorText: response.data.message})
                }
            );
        }
    };

    togglePopover = (id) => {

        //console.log("togglePopover")

        if(this.state.popoverOpen !== -1) {
            this.setState({popoverOpen: -1});
        }
        else {
            this.setState({popoverOpen: id});
        }
    };

    updateComment = (value, type) => {
        if (type === 1) {
            let updatedFormFields = {...this.state.formFields};

            let userType = undefined;
            if (this.props.userData && this.props.userData.data && this.props.userData.data.userType !== undefined) {
                userType = this.props.userData.data.userType;
            }

            updatedFormFields['lu_by_user_type'] = userType;

            this.setState({comment: value, formFields: updatedFormFields});
        } else {
            let updatedFormFields = {...this.state.formFields};

            this.setState({commentD: value, commentForDealReminder: 1, formFields: updatedFormFields});
        }
    };

    formFieldValueChanged = (type, value, value1) => {

        let updatedFormFields = {...this.state.formFields};

        let userType = undefined;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.userType !== undefined) {
            userType = this.props.userData.data.userType;
        }

        if (type === 'commentsManager') {
            if (this.props.userData.data.isManager || this.props.userData.data.isAdmin) {
                updatedFormFields[type] = value;
                this.setState({formFields: updatedFormFields});
            }
        } else if (type === 'commentsStore') {

            //console.log("commentsStorechange", type, value, userType);
            if (!this.props.userData.data.isManager && !this.props.userData.data.isAdmin) {
                updatedFormFields[type] = value;
                updatedFormFields['lu_by_user_type'] = userType;
                this.setState({formFields: updatedFormFields});
            }
        } else if (type === 'deal_reminder') {
            if ((this.state.formFields.deal_reminder === false || this.state.formFields.deal_reminder === 0) && value === true) {
                this.setState({shouldDealReminderUpdate: 1});
            }

            updatedFormFields[type] = value;
            updatedFormFields['lu_by_user_type'] = userType;
            this.setState({formFields: updatedFormFields});
        } else if(type === 'city') {
            updatedFormFields['city'] = value;
            updatedFormFields['cityName'] = value1;
            updatedFormFields['lu_by_user_type'] = userType;
            this.setState({formFields: updatedFormFields});
        } else if(type === 'street') {
            console.log("HERE")
            updatedFormFields['street'] = value;
            updatedFormFields['streetName'] = value1;
            updatedFormFields['lu_by_user_type'] = userType;
            this.setState({formFields: updatedFormFields});
        }
        else {
            updatedFormFields[type] = value;
            updatedFormFields['lu_by_user_type'] = userType;
            this.setState({formFields: updatedFormFields});
        }
    };

    cardFocusChanged = (type) => {

        let cardFocus = "";
        let cardValidWarning = "";
        let cardFocusCurr = type;
        
        switch (type) {
            case "cardNumber":
                cardFocus = "number";
                break;
            case "validationDate":
                cardFocus = "expiry";
                break;
            case "cvv":
                cardFocus = "cvc";
                break;
            default:
                cardFocus = "";
                break;
        }

        // Check credit card number
        if(this.state.cardFocusPrev === 'cardNumber') {
            if(!this.getCvv().includes('*')) {
                if(!this.validateCardNumber(this.state.formFields.paymentDetails.cardNumber)) {
                    cardValidWarning = 'מספר של כרטיס האשראי אינו תקין';
                }
            }
        }
        this.setState({cardFocus: cardFocus, cardFocusPrev: cardFocusCurr, cardValidWarning: cardValidWarning});
    };

    passportLoseFocus = (isStore) => {
        if(isStore) {
            this.setState({isPassportShow: true});
        }

        if (!checkId(this.state.formFields.id)) {
            this.setState({warning: 'מספר תז לא תקין'});
        }
    };

    isSimOrSendLoseFocus = (type) => {
        //console.log("HERE")
        //if(!this.state.isESimFiled) {
        if(type === 2) { // 2 -> eSim
            this.setState({isESimShow: true});
        }
    };

    paymentDetailsChanged = (type, value, once) => {
        let updatedPaymentDetails = {...this.state.formFields.paymentDetails};

        updatedPaymentDetails[type] = value;

        if (type === 'cardNumber' &&
            updatedPaymentDetails['cardNumberImport'] !== '' && updatedPaymentDetails['cardNumberImport'] !== undefined &&
            once === undefined) {
            updatedPaymentDetails['cardNumberImport'] = '';
            updatedPaymentDetails['cardNumber'] = '';
        }

        if (type === 'cvv' &&
            updatedPaymentDetails['cvvImport'] !== '' && updatedPaymentDetails['cvvImport'] !== undefined &&
            once === undefined) {
            updatedPaymentDetails['cvvImport'] = '';
            updatedPaymentDetails['cvv'] = '';
        }

        let updatedPaymentFormFields = {...this.state.formFields, paymentDetails: updatedPaymentDetails};
        this.setState({formFields: updatedPaymentFormFields});
    };

    getProviderId = () => {
        if (this.props.location.state && this.props.location.state.id) {
            // it comes from path
            return this.props.location.state.id;
        } else {
            //it comes from props
            /*if (this.props.customer && this.props.customer.providerId) {
                return this.props.customer.providerId;
            }*/

            if (this.state.formFields && this.state.formFields.providerId) {
                return this.state.formFields.providerId;
            }

        }
    };

    validateCardNumber = (number) => {
        //Check if the number contains only numeric value
        //and is of between 13 to 19 digits
        /*const regex = new RegExp("^[0-9]{13,19}$");
        if (!regex.test(number)){
            return false;
        }

        return luhnCheck(number);*/

        let checksum = 0; // running checksum total
        let j = 1; // takes value of 1 or 2

        // Process each digit one by one starting from the last
        for (let i = number.length - 1; i >= 0; i--) {
            let calc = 0;
            // Extract the next digit and multiply by 1 or 2 on alternative digits.
            calc = Number(number.charAt(i)) * j;

            // If the result is in two digits add 1 to the checksum total
            if (calc > 9) {
                checksum = checksum + 1;
                calc = calc - 10;
            }

            // Add the units element to the checksum total
            checksum = checksum + calc;

            // Switch the value of j
            if (j === 1) {
                j = 2;
            } else {
                j = 1;
            }
        }

        //Check if it is divisible by 10 or not.
        return (checksum % 10) === 0;
    };

    saveCustomer = () => {

        //console.log(this.state.formFields.hotAutoDetail);

        let isNew = this.props.location.state && this.props.location.state.name;

        let isStoreHandleName = false;

        if (this.props.userData && this.props.userData.data) {
            if (!this.props.userData.data.isAdmin && !this.props.userData.data.isManager) {

                if (this.props.userData.data.handleName !== undefined && this.props.userData.data.handleName !== '') {
                    isStoreHandleName = true;
                }
            }
        }

        let isStore = false;
        if (!this.props.userData.data.isAdmin && !this.props.userData.data.isManager) {
            isStore = true;
        }

        let providerId = this.getProviderId();

        // Self Deal
        if (this.state.selfDeal) {
            if (!this.state.formFields.customerName || this.state.formFields.customerName === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }
            if (!this.state.formFields.id || this.state.formFields.id === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.passportMandatoryField});
                return;
            }

            if (!this.state.formFields.customerId || this.state.formFields.customerId === '') {
                this.setState({warning: 'שדה מספר לקוח - חובה'});
                return;
            }

            if (this.state.formFields.dealType === 1) {
                let shouldReurn = false;
                this.state.formFields.lines.forEach((line) => {
                    if (line.question && line.question === 1 && (!line.customerNumber || line.customerNumber === "")) {
                        this.setState({warning: "מספר מנוי הוא שדה חובה"});
                        shouldReurn = true;
                    }

                    line.status = 1;
                });

                if (shouldReurn) {
                    return
                }
            }
        }
        else {

            if (!this.state.formFields.customerName || this.state.formFields.customerName === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }
            if (!this.state.formFields.id || this.state.formFields.id === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.passportMandatoryField});
                return;
            }

            if (!checkId(this.state.formFields.id)) {
                this.setState({warning: 'מספר תז לא תקין'});
                return;
            }

            /*if (!this.state.formFields.address || this.state.formFields.address === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.addressIsMandatoryField});
                return;
            }*/

            if(isNew) {
                if (!this.state.formFields.cityName || this.state.formFields.cityName === '') {
                    this.setState({warning: "עיר היא שדה חובה"});
                    return;
                }

                if (!this.state.formFields.streetName || this.state.formFields.streetName === '') {
                    this.setState({warning: "רחוב הוא שדה חובה"});
                    return;
                }

                if (!this.state.formFields.number || this.state.formFields.number === '') {
                    this.setState({warning: "מספר בית/בניין הוא שדה חובה"});
                    return;
                }

                if (this.state.formFields.dealType === 2 || this.state.formFields.dealType === 3) {
                    if (!this.state.formFields.flat || this.state.formFields.flat === '') {
                        this.setState({warning: "מספר דירה הוא שדה חובה"});
                        return;
                    }
                    if (!this.state.formFields.floor || this.state.formFields.floor === '') {
                        this.setState({warning: "מספר קומה הוא שדה חובה"});
                        return;
                    }
                }
            }

            if (this.state.formFields.dealType === 1) {
                if (this.state.formFields.lines.length === 0) {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.lineIsMandatoryField});
                    return;
                }
                if (this.state.formFields.contact === "") {
                    this.setState({warning: "שדה יצירת קשר הוא חובה"});
                    return;
                }

                if(this.state.formFields.mail.length > 0 && !validateEmail(this.state.formFields.mail)) {
                    this.setState({warning: "נא לכתוב מייל תקין או להשאיר את השדה ריק"});
                    return;
                }

                if (isNew && (this.props.userData.data.isManager !== true && this.props.userData.data.isAdmin !== true) &&
                    (this.state.formFields.contact.length !== 10)) {
                    this.setState({warning: "יצירת קשר חייב להיות באורך של 10 מספרים"});
                    return;
                }
            }
            if (this.state.formFields.dealType === 2) {
                if (this.state.formFields.tv.mail === "") {
                    this.setState({warning: "שדה המייל הוא חובה"});
                    return;
                }
                if (!validateEmail(this.state.formFields.tv.mail)) {
                    this.setState({warning: "נא לכתוב מייל תקין"});
                    return;
                }
                if (this.state.formFields.tv.numberOfConvertors === "") {
                    this.setState({warning: "אנא הזן מספר ממירים"});
                    return;
                }
                if (this.state.formFields.tv.executorDetails === "") {
                    this.setState({warning: "אנא הזן פרטי מבצע"});
                    return;
                }
            }
            else {
                if (this.state.formFields.dealType === 1) {
                    let shouldReurn = false;
                    this.state.formFields.lines.forEach((line) => {
                        if (!line.deal.text || line.deal.text.length === 0 || !line.deal.amount || line.deal.amount.length === 0) {
                            this.setState({warning: TextManager.getCurrentTextResource().Text.dealFieldsCantBeEmpty});
                            shouldReurn = true;
                        }
                        if(isNew && line.isSimOrSend === undefined) {
                            this.setState({warning: TextManager.getCurrentTextResource().Text.simOrSendMandatoryField});
                            shouldReurn = true;
                        }
                        if(line.isSimOrSend === 1 && (!line.simNumber || line.simNumber.length === 0)) {
                            this.setState({warning: TextManager.getCurrentTextResource().Text.simNumberMandatoryField});
                            shouldReurn = true;
                        }

                        if(isStore && line.isSimOrSend === 1) {
                            if((providerId === 9 || providerId === 25) && (line.simNumber.length !== 19)) { // Pelephone
                                let text = "שים-לב בחברת פלאפון יש 19 ספרות על המקט של הסים, נא למלא בהתאם, תודה!";
                                this.setState({warning: text});
                                shouldReurn = true;
                            }
                            else if((providerId === 6 || providerId === 27) && (line.simNumber.length !== 18)) { // Cellcom
                                let text = "שים-לב בחברת סלקום יש 18 ספרות על המקט של הסים, נא למלא בהתאם, תודה!";
                                this.setState({warning: text});
                                shouldReurn = true;
                            }
                            else if((providerId === 4 || providerId === 28) && (line.simNumber.length !== 18)) { // Golan
                                let text = "שים-לב בחברת גולן טלקום יש 18 ספרות על המקט של הסים, נא למלא בהתאם, תודה!";
                                this.setState({warning: text});
                                shouldReurn = true;
                            }
                            else if((providerId === 2) && (line.simNumber.length !== 20)) { // WE.com
                                let text = "שים-לב בחברת we-com יש 20 ספרות על המקט של הסים, נא למלא בהתאם, תודה!";
                                this.setState({warning: text});
                                shouldReurn = true;
                            }
                            else if((providerId === 7 || providerId === 26) && (line.simNumber.length !== 20)) { // Partner
                                let text = "שים-לב בחברת פרטנר יש 20 ספרות על המקט של הסים, נא למלא בהתאם, תודה!";
                                this.setState({warning: text});
                                shouldReurn = true;
                            }
                            else if((providerId === 1 || providerId === 20) && (line.simNumber.length !== 19)) { // Hot
                                let text = "שים-לב בחברת הוט מובייל יש 19 ספרות על המקט של הסים, נא למלא בהתאם, תודה!";
                                this.setState({warning: text});
                                shouldReurn = true;
                            }
                        }

                        if (line.question && line.question === 1 && (!line.customerNumber || line.customerNumber === "" )) {
                            this.setState({warning: "מספר מנוי הוא שדה חובה"});
                            shouldReurn = true;
                        }

                        if (isNew && (this.props.userData.data.isManager !== true && this.props.userData.data.isAdmin !== true) &&
                            (line.customerNumber.length > 0) && (line.customerNumber.length !== 10 )) {
                            this.setState({warning: "מספר מנוי חייב להיות באורך של 10 מספרים"});
                            shouldReurn = true;
                        }

                        if(isNew && line.isSimOrSend === 2 &&
                            ((!this.state.formFields.eSimDetail.phone_number || this.state.formFields.eSimDetail.phone_number.length === 0) &&
                            (!this.state.formFields.eSimDetail.email || this.state.formFields.eSimDetail.email.length === 0))) {
                            this.setState({warning: 'מספר טלפון אחר או כתובת מייל - חובה --eSim--'});
                            shouldReurn = true;
                        }

                        if(!isNew && (providerId === 1 || providerId === 5 || providerId === 20) && (environment.ListManagersFeatures.includes(this.props.userData.data.id) || this.props.userData.data.isAdmin)) {
                            if (!line.uniqueId || line.uniqueId === '') {
                                this.setState({warning: 'שדה ייחודי - חובה'});
                                shouldReurn = true;
                            }
                        }

                        // If Pelephon or Golan  -> tempSim = NO
                        if(isNew && (providerId === 4 || providerId === 9 || providerId === 25 || providerId === 28)) {
                            line.isTempNumber = 0;
                        }
                        // If Celcom or Hot and New Number -> tempSim = NO
                        if(isNew && (providerId === 6 || providerId === 1 || providerId === 20 || providerId === 27) && line.isNewNumber === 0) {
                            line.isTempNumber = 0;
                        }
                    });

                    if (!isNew && this.props.userData.data.isManager && this.state.formFields.lines
                        && this.state.formFields.lines.length > 0 && this.state.formFields.lines[0].handleName === 0) {
                        this.setState({warning: "שם משווק הוא שדה חובה"});
                        shouldReurn = true;
                    }

                    if (isStoreHandleName && this.state.formFields.lines
                        && this.state.formFields.lines.length > 0 && this.state.formFields.lines[0].handleName === 0) {
                        this.setState({warning: "שם משווק הוא שדה חובה"});
                        shouldReurn = true;
                    }
                    //console.log(this.state.formFields.lines[0].handleName);

                    if (shouldReurn) {
                        return
                    }
                }
            }

            if (this.state.formFields.paymentMethod === "credit") {
                if (!this.state.formFields.paymentDetails) {
                    return;
                }
                /*if (!this.state.formFields.paymentDetails.cardType || this.state.formFields.paymentDetails.cardType === '') {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                    return;
                }*/
                if (!this.state.formFields.paymentDetails.cardNumber || this.state.formFields.paymentDetails.cardNumber === '') {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                    return;
                }

                if (!this.state.formFields.paymentDetails.validationDate) {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                    return;
                } else {
                    let date = this.state.formFields.paymentDetails.validationDate.split('/');

                    let today = new Date();
                    let check = new Date();

                    check.setFullYear(parseInt(date[1]) + 2000, parseInt(date[0]) - 1, 1);

                    if (check < today) {
                        this.setState({warning: 'תוקף של כרטיס האשראי אינו תקין'});
                        return;
                    }

                }
                /* if (!this.state.formFields.paymentDetails.validationDate || this.state.formFields.paymentDetails.validationDate.length !== 5) {
                     this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                     return;
                 }*/
                if (!this.state.formFields.paymentDetails.cvv || this.state.formFields.paymentDetails.cvv.length < 3) {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.ccvNotValid});
                    return;
                }
                else {
                    if(!this.getCvv().includes('*')) {
                        if(!this.validateCardNumber(this.state.formFields.paymentDetails.cardNumber)) {
                            this.setState({warning: 'מספר של כרטיס האשראי אינו תקין'});
                            //return;
                        }
                    }
                }
            }

            if (this.state.formFields.paymentMethod === "bank") {
                if (!this.state.formFields.paymentDetails) {
                    return;
                }
                if (!this.state.formFields.paymentDetails.bank || this.state.formFields.paymentDetails.bank === '') {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                    return;
                }
                if (!this.state.formFields.paymentDetails.bankAccountBranch || this.state.formFields.paymentDetails.bankAccountBranch === '') {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                    return;
                }
                if (!this.state.formFields.paymentDetails.bankAccountNumber || this.state.formFields.paymentDetails.bankAccountNumber === '') {
                    this.setState({warning: TextManager.getCurrentTextResource().Text.paymentDetailsAreMissing});
                    return;
                }
            }

            if (this.props.userData.data.isManager && !isNew) {
                if (!this.state.formFields.careBy || this.state.formFields.careBy === '') {
                    this.setState({warning: 'שדה נציג מטפל - חובה'});
                    return;
                }

                if (!this.state.formFields.customerId || this.state.formFields.customerId === '') {
                    this.setState({warning: 'שדה מספר לקוח - חובה'});
                    return;
                }
            }

            if (providerId === 15 && !isNew && this.props.userData.data.isManager) {
                if (!this.state.formFields.given_number || this.state.formFields.given_number === '') {
                    this.setState({warning: 'שדה מספר מוקצה - חובה'});
                    return;
                }
            }

            if (this.state.shouldDealReminderUpdate === 1 && this.state.commentForDealReminder === 0) {
                this.setState({warning: 'חובה לרשום הערה בצ\'אט למתפעלים כשמסמנים תזכורת!'});
                return;
            }


        }

        let chat = this.state.formFields.chat;
        let chatDealReminder = this.state.formFields.chatDealReminder;

        if (!isNew) {
            http.postToServer(
                'customers/get_chat',
                {id: parseInt(this.props.customer.id), type: 0},
                (response) => {
                    chat = response.data.chat;
                    chatDealReminder = response.data.chatDealReminder;
                },
                (response) => {
                    console.log('error get chat');
                }
            );
        }

        if (this.state.comment !== '') {
            chat.push({
                name: this.props.userData.data.name, message: this.state.comment, date: moment().format('llll'),
                isStore: (this.props.userData.data.isManager !== true && this.props.userData.data.isAdmin !== true) ? 1 : 0
            })
        }

        if (this.state.commentD !== '') {
            chatDealReminder.push({
                name: this.props.userData.data.name, message: this.state.commentD, date: moment().format('llll'),
                isStore: 0
            })
        }


        this.setState({warning: '', saving: true, error: false});
        //let providerName = this.getProviderName();


        let storeId = this.props.userData.data.id;

        if (isNew) {
            if (this.props.userData.data.isManager || this.props.userData.data.isAdmin) {
                storeId = this.state.formFields.storeId;
            } else {
                if (this.props.userData.data.storeId !== 0 && this.props.userData.data.storeId !== undefined) {
                    storeId = this.props.userData.data.storeId;
                }
            }
        }

        if (isNew && this.state.formFields && this.state.formFields.lines) {
            this.state.formFields.lines.forEach((line) => {
                line.question = 0;
            })
        }

        //console.log(this.state.formFields.hotAutoDetail);

        let customerData = {
            id: isNew ? 0 : this.props.customer.id,
            name: this.state.formFields.customerName,
            customerId: this.state.formFields.customerId,
            passport: this.state.formFields.id,
            address: this.state.formFields.address,
            providerId: isNew ? providerId : this.state.formFields.providerId,
            providerName: isNew ? '' : this.state.formFields.providerName,
            storeId: isNew ? storeId : this.state.formFields.storeId,
            storeName: this.state.formFields.storeName,
            numOfLines: this.state.formFields.lines ? this.state.formFields.lines.length : 0,
            lines: this.state.formFields.lines,
            tv: this.state.formFields.tv,
            internet: this.state.formFields.internet,
            status: this.state.selfDeal ? 2 : isNew ? 1 : this.state.formFields.status,
            secondStatus: this.state.selfDeal ? 1 : isNew ? 0 : this.state.formFields.secondStatus,
            paymentMethod: this.state.formFields.paymentMethod,
            paymentDetails: this.state.formFields.paymentDetails,
            day: isNew ? '' : this.state.formFields.day,
            manageDay: isNew ? '' : this.state.formFields.manageDay,
            updateDay: isNew ? '' : this.state.formFields.updateDay,
            lu_by_user_type: isNew ? undefined : (this.state.formFields.lu_by_user_type !== undefined && this.state.formFields.lu_by_user_type !== null) ? this.state.formFields.lu_by_user_type : undefined,
            dealType: parseInt(this.state.formFields.dealType),
            careBy: parseInt(this.state.formFields.careBy),
            lastUpdateBy: (this.props.userData.data.isManager && !isNew) ? parseInt(this.props.userData.data.id) : this.state.formFields.lastUpdateBy,
            chat: chat,
            contact: this.state.formFields.contact,
            mail: this.state.formFields.mail,
            is_duplicate: this.state.formFields.is_duplicate,
            given_number: this.state.formFields.given_number,
            admin_comment: this.state.formFields.admin_comment,
            as_new: this.state.formFields.as_new ? 1 : 0,
            deal_reminder: this.state.formFields.deal_reminder ? 1 : 0,
            external_id: this.state.formFields.external_id,
            chatDealReminder: chatDealReminder,
            deal_image: (this.state.formFields.deal_image !== undefined && this.state.formFields.deal_image !== null) ? this.state.formFields.deal_image : 0,
            isAuto: (this.state.formFields.isAuto !== undefined && this.state.formFields.isAuto !== null) ? this.state.formFields.isAuto : [],
            autoMes: (this.state.formFields.autoMes !== undefined && this.state.formFields.autoMes !== null) ? this.state.formFields.autoMes : "",
            autoDealDetail: (this.state.formFields.autoDealDetail !== undefined && this.state.formFields.autoDealDetail !== null) ? this.state.formFields.autoDealDetail : [],
            city: this.state.formFields.city,
            cityName: this.state.formFields.cityName,
            street: this.state.formFields.street,
            streetName: this.state.formFields.streetName,
            number: this.state.formFields.number,
            flat: this.state.formFields.flat,
            floor: this.state.formFields.floor,
            uniqueId: this.state.formFields.uniqueId,
            eSimDetail: this.state.formFields.eSimDetail,
            hotAutoDetail: this.state.formFields.hotAutoDetail
        };

        //console.log(customerData);
        //console.log("this.state.formFields", this.state.formFields);
        //console.log("customerData", customerData);

        let requestUrl = 'customers/new';

        if (!isNew) {
            requestUrl = 'customers/update';
        }

        http.postToServer(
            requestUrl,
            customerData,
            (response) => {
                if (!isNew) {
                    this.setState({saving: false, error: false, saved: false});
                    this.props.dispatch(customer_update(response.data));
                    this.props.onClose();
                } else {
                    this.props.dispatch(customer_insert(response.data));
                    this.setState({saving: false, error: false, success: true});
                }
            },
            (response) => {
                this.setState({saving: false, error: true, errorText: response.data});
            }
        );
    };

    closeDeal = () => {

        if (this.state.now_handle_by === this.props.userData.data.id) {
            //console.log("Clear")
            http.postToServer(
                'customers/cancel_edit?customerId=' + this.props.customer.id + '&storeId=' + this.props.userData.data.id,
                {},
                (response) => {
                    //console.log(response.data);
                    //this.setState({now_handle_by: response.data[0].now_handle_by})
                },
                (response) => {
                    //console.log('error ' + response.data);
                    //this.setState({errorText: response.data.message})
                }
            );
        }

        this.setState({saved: true});
    };

    sendAsEnvelope = () => {

        http.postToServer(
            'customers/as_envelope?customerId=' + this.props.customer.id,
            {},
            (response) => {
                this.formFieldValueChanged('lu_by_user_type', environment.ListUserTypesEnum.Store);
                this.props.onClose();
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
            }
        );

    };

    linesChanged = (change, index, field, value) => {

        const formFieldsNewState = {...this.state.formFields};

        switch (change) {
            case 'delete':
                const newDeleteLinesState = [...formFieldsNewState.lines].filter((line, i) => i !== index);
                formFieldsNewState.lines = newDeleteLinesState;
                break;
            case 'update':
                const newUpdateLinesState = [...formFieldsNewState.lines];
                newUpdateLinesState[index][field] = value;
                formFieldsNewState.lines = newUpdateLinesState;
                break;
            case 'add':
                const newAddLinesState = [...this.state.formFields.lines, {
                    customerNumber: "",
                    simNumber: "",
                    deal: this.props.dealsList[0],
                    status: 3,
                    secondStatus: 0,
                    notes: '',
                    question: 0,
                    handleName: 0,
                    isNewNumber: 0
                }];
                formFieldsNewState.lines = newAddLinesState;
                break;
            default:
                break;
        }

        this.setState({formFields: formFieldsNewState});

    };

    dynamicFieldChanged = (field, value, type = "tv") => {
        const formFieldsNewState = {...this.state.formFields};
        formFieldsNewState[type][field] = value;
        this.setState({formFields: formFieldsNewState});

    };

    dealChanged = (index, value) => {
        const newDeal = {amount: value.amount, text: value.value, tashvuId: value.tashvuId, comment: value.comment, autoId: value.autoId};

        const newLinesState = [...this.state.formFields.lines];
        newLinesState[index].deal = newDeal;

        const formFieldsNewState = {...this.state.formFields, lines: newLinesState};

        this.setState({formFields: formFieldsNewState});

        if(value.comment !== '' && value.comment !== undefined) {
            this.togglePopover(index);
        }
    };

    addLine = () => {
        this.linesChanged("add");
    };

    limit = (val, max) => {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    };

    cardExpiry = (val) => {
        let month = this.limit(val.substring(0, 2), '12');
        let year = val.substring(2, 4);

        return month + (year.length ? '/' + year : '');
    };

    changeLineStatus = (type, index) => {
        if (this.props.userData.data.isManager || this.props.userData.data.isAdmin) {
            const tmp = [...this.state.formFields.lines];

            //tmp[index][type] = tmp[index][type] === 0 ? 1 : 0;

            if (type === "status") {
                tmp[index][type] = this.changeLineStatusStateMachine(tmp[index][type]); //tmp[index][type] === 0 ? 2 : tmp[index][type] === 2 ? 1 : 0;
            } else {
                tmp[index][type] = tmp[index][type] === 0 ? 1 : 0;
            }

            const formFieldsNewState = {...this.state.formFields, lines: tmp};

            this.setState({formFields: formFieldsNewState});
        }
    };

    changeLineStatusStateMachine = (currentStatus) => {
        if(currentStatus === 3)
            return 0;
        else if(currentStatus === 0)
            return 2;
        else if(currentStatus === 2)
            return 1;
        else if(currentStatus === 1)
            return 3;
        else
            return 3;
    };

    deleteMessage = (mesId, type) => {

        if (type === 1) {
            let tmp = this.state.formFields.chat.slice();
            tmp.splice(mesId, 1);

            this.formFieldValueChanged('chat', tmp);
        } else {
            let tmp = this.state.formFields.chatDealReminder.slice();
            tmp.splice(mesId, 1);

            this.formFieldValueChanged('chatDealReminder', tmp);
        }

        //this.props.dispatch(customer_update(response.data));
    };

    getKasherText = () => {
        if (this.state.formFields.storeId === 23 ||
            this.state.formFields.storeId === 121 ||
            this.state.formFields.storeId === 120 ||
            this.state.formFields.storeId === 122 ||
            this.state.formFields.storeId === 48) {
            return "יוזר: 316561851";
        } else if (this.state.formFields.storeId === 7 ||
            this.state.formFields.storeId === 15 ||
            this.state.formFields.storeId === 167) {
            return "יוזר: 304914740";
        } else if (this.state.formFields.storeId === 85 ||
            this.state.formFields.storeId === 6 ||
            this.state.formFields.storeId === 13) {
            return "יוזר: 304798556";
        } else {
            return "היוזר: 316290394";
        }
    };

    getHotRegularText = () => {
        return "היוזר: 316290394";
    };

    isDirectCard = () => {
        let res = false;
        let cardNum = this.state.formFields.paymentDetails.cardNumber;

        if (cardNum !== '') {
            if (cardNum.startsWith('458042') || cardNum.startsWith('458047') || cardNum.startsWith('45808000') ||
                cardNum.startsWith('458052') || cardNum.startsWith('458047') || cardNum.startsWith('45808300') ||
                cardNum.startsWith('4200') || cardNum.startsWith('532614') || cardNum.startsWith('4147')) {
                res = true;
            }
        }
        return res;
    };

    getCardNumber = () => {
        if (this.state.formFields.paymentDetails.cardNumber ||
            this.state.formFields.paymentDetails.cardNumberImport) {

            if (this.state.formFields.paymentDetails.cardNumberImport) {
                return this.state.formFields.paymentDetails.cardNumberImport
            } else {
                return this.state.formFields.paymentDetails.cardNumber
            }
        } else {
            return '';
        }
    };

    getCvv = () => {
        if (this.state.formFields.paymentDetails.cvv ||
            this.state.formFields.paymentDetails.cvvImport) {

            if (this.state.formFields.paymentDetails.cvvImport) {
                return this.state.formFields.paymentDetails.cvvImport
            } else {
                return this.state.formFields.paymentDetails.cvv
            }
        } else {
            return '';
        }
    };

    checkImport = () => {
        http.postToServer(
            'customers/check_find_customer?passport=' + this.state.formFields.id + '&storeId=' + this.props.userData.data.id,
            {},
            (response) => {
                //console.log(response.data);
                if (response.data > 0) {
                    this.setState({isDataToImport: true})
                }

            },
            (response) => {
                console.log('error ' + response);
                //this.setState({errorText: response.data.message})
            }
        );
    };

    getImport = () => {

        if (this.state.formFields.id && this.state.formFields.id !== '') {
            http.postToServer(
                'customers/find_customer?passport=' + this.state.formFields.id + '&storeId=' + this.props.userData.data.id,
                {},
                (response) => {
                    //console.log(response.data);
                    this.formFieldValueChanged('address', response.data[0].address);
                    this.formFieldValueChanged('city', response.data[0].city);
                    this.formFieldValueChanged('cityName', response.data[0].cityName);
                    this.formFieldValueChanged('street', response.data[0].street);
                    this.formFieldValueChanged('streetName', response.data[0].streetName);
                    this.formFieldValueChanged('number', response.data[0].number);
                    this.formFieldValueChanged('flat', response.data[0].flat);
                    this.formFieldValueChanged('floor', response.data[0].floor);
                    this.formFieldValueChanged('contact', response.data[0].contact);
                    this.formFieldValueChanged('mail', response.data[0].mail);
                    this.formFieldValueChanged('customerName', response.data[0].name);

                    this.formFieldValueChanged('paymentMethod', response.data[0].paymentMethod);

                    this.paymentDetailsChanged('bank', response.data[0].paymentDetails.cardNumber);
                    this.paymentDetailsChanged('bankAccountBranch', response.data[0].paymentDetails.bankAccountBranch);
                    this.paymentDetailsChanged('bankAccountNumber', response.data[0].paymentDetails.bankAccountNumber);
                    this.paymentDetailsChanged('cardNumber', response.data[0].paymentDetails.cardNumber, true);
                    this.paymentDetailsChanged('cardNumberImport', response.data[0].paymentDetails.cardNumberImport);
                    this.paymentDetailsChanged('cardType', response.data[0].paymentDetails.cardType);
                    this.paymentDetailsChanged('cvv', response.data[0].paymentDetails.cvv, true);
                    this.paymentDetailsChanged('cvvImport', response.data[0].paymentDetails.cvvImport);
                    this.paymentDetailsChanged('validationDate', response.data[0].paymentDetails.validationDate);

                    for (let i = 0; i < response.data[0].numOfLines - 1; i++) {
                        this.linesChanged("add");
                    }

                    response.data[0].lines.forEach((line, index) => {
                        this.linesChanged("update", index, "customerNumber", line.customerNumber);
                        this.linesChanged("update", index, "isNewNumber", 1);
                    })

                },
                (response) => {
                    console.log('error ' + response);
                    //this.setState({errorText: response.data.message})
                }
            );
        }
    };

    checkHotCustomer = () => {
        http.postToServer(
            'customers/check_hot_customer?passport=' + this.state.formFields.id,
            {},
            (response) => {
                console.log(response.data);
                if (response.data) {
                    this.setState({isHotCustomer: true})
                }

            },
            (response) => {
                console.log('error ' + response);
                //this.setState({errorText: response.data.message})
            }
        );
    };

    changeProvider = (value) => {
        let updatedFormFields = {...this.state.formFields};
        updatedFormFields.providerId = value;
        this.setState({formFields: updatedFormFields, wasProviderChanged: true});

        this.props.dispatch(fetchSalesItemDataIfNeeded(value));
    };

    changeStore = (value) => {
        let updatedFormFields = {...this.state.formFields};
        updatedFormFields.storeId = value;

        if (this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.stores) {
            updatedFormFields.storeName = this.props.utilsData.data.stores.find(a => a.value === value).label;
        }
        this.setState({formFields: updatedFormFields});

    };

    sendToTashvuLi = () => {

        http.postToServer(
            'customers/send_to_tashvu?customerId=' + this.props.customer.id,
            {},
            (response) => {
                console.log(response.data);
                alert("העסקה נשלחה בהצלחה");
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
                alert("שגיאה בשליחת העסקה");
            }
        );

        /*http.postToServer(
            'customers/status_from_tashvu',
            {
                "tashvu_deal_id": 111,
                "deal_id": 222,
                "status_list" : [
                    {
                        "deal": 1,
                        "status": 1
                    },
                    {
                        "deal":2,
                        "status":2
                    }
                ]
            },
            (response) => {
                console.log(response.data);
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
            }
        );*/

        /*http.postToServer(
            'customers/receive_from_tashvu',
            {
                "user_id":"797",
                "type":"cellular",
                "name":"name",
                "lname":"surname",
                "birthday":"",
                "deal_detail":
                    [
                        {
                            "item_num":0,
                            "package_id":13,
                            "sim_number":"2345235453",
                            "tel_number":""
                        }
                    ],
                "passport_id":"337586226",
                "cphone1":"34543534534",
                "category_id":1,
                "company_id":7,
                "is_exists_customer":0,
                "pay_type":"BANK",
                "pay_bank_num":"10",
                "pay_bank_dept_id":"934",
                "pay_bank_account":"123456789",
                "type_deal":"NEW",
                "tashvu_deal_id":19122,
                "deal_id":19122
            },
            (response) => {
                console.log(response.data);
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
            }
        );*/


    };

    sendToAuto = () => {

        /*http.postToServer(
            'api_auto/deal/test?dealId=' + this.props.customer.id,
            {},
            (response) => {
                console.log(response.data);
                alert("העסקה נשלחה בהצלחה");
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
                //alert("שגיאה בשליחת העסקה");
            }
        );*/

        http.postToServer(
            'api_auto/deal/get?token=PZCnuMkY2Bp8SpqXMGIE19ec5quVeLsw&user_id=' + this.props.customer.id,
            {},
            (response) => {
                console.log(response.data);
                alert("העסקה נשלחה בהצלחה");
            },
            (response) => {
                //this.setState({saving: false, error: true, errorText: response.data});
                //alert("שגיאה בשליחת העסקה");
            }
        );
    };

    filterProviders = (item) => {
        let typeInt = parseInt(this.state.formFields.dealType);
        if (typeInt === 1 || typeInt === 4) {
            return (item.providerType === 1 || item.providerType === 4);
        } else {
            return item.providerType === typeInt;
        }
    };

    checkIVR = (providerId, customerNumber) =>
    {
        return (providerId === 6 || // cellcom
            providerId === 7 || // partner
            providerId === 3 || // 012
            providerId === 5 || // walla
            providerId === 9 || // pelephone
            providerId === 1 || // hot mobile regular
            providerId === 20 || // הוט מובייל כשר
            providerId === 25 || // פלאפון כשר
            providerId === 26 || // פרטנר כשר
            providerId === 27 || // סלקום כשר
            providerId === 29 || // רמי לוי תקשורת - כשר
            providerId === 4 || // golan
            providerId === 28 || // golan כשר
            providerId === 8) && customerNumber !== ''    // rami
    };

    sendIVR = (providerId, customerNumber) => {

        let provider = "";

        switch(providerId)
        {
            case 6:
            case 27:
                provider = 'cellcom';
                break;
            case 7:
            case 26:
                provider = 'partner';
                break;
            case 3:
                provider = '012m';
                break;
            case 9:
            case 25:
                provider = 'pelephone';
                break;
            case 1:
            case 20:
            case 5: // walla same as hot
                provider = 'hotm';
                break;
            case 8:
            case 29:
                provider = 'rami';
                break;
            case 4:
            case 28:
                provider = 'golan';
                break;
            default:
                break;
        }

        if(provider !== ""){

            http.postToServer(
                'clickone/send?provider=' + provider + '&phone=' + customerNumber,
                {},
                (response) => {
                    console.log(response.data);
                    alert("נשלח בהצלחה");
                },
                (response) => {
                    //this.setState({saving: false, error: true, errorText: response.data});
                    alert("שגיאה בשליחה");
                }
            );
        }
    };

    getLineStatusText = (status) => {
        if(status === 0)
            return TextManager.getCurrentTextResource().Customers.notActive;
        else if (status === 1)
            return TextManager.getCurrentTextResource().Customers.active;
        else if(status === 2)
            return TextManager.getCurrentTextResource().Customers.dealStarted;
        else if(status === 3)
            return 'בטיפול';
        else
            return '';
    };

    getLineStatusColor = (status) => {
        if (status === 0)
            return "danger";
        else if (status === 1)
            return "success";
        else if(status === 2)
            return "primary";
        else if(status === 3)
            return "other";
        else
            return "primary";
    };

    getNoImagePart = (isNew, logoUrl, provider, isManager, isAdmin, isSendTashvu, isCellcom,
                      allProviders, stores, isKosher, likeKosher, transferQuestionOptions,
                      transferQuestionOptionsOnAdd, isStore, tvDealOption, dealsStatusTypes,
                      bezekHotRestOption, internetDealOption, handleName, isStoreHandleName,
                      providerId, isDirect, cardNumber, cvv) => {

        let allCities = TextManager.getAllCities().map(a => {return {
            value: a.city_symbol,
            label: a.city_name
        }});


        let allStreets = [];
        if(this.state.formFields.city !== undefined){
            allStreets = TextManager.getAllStreets().filter(u => {return (u.city_symbol === this.state.formFields.city)}).map(a => {return {
                value: a.street_symbol,
                label: a.street_name
            }});
        }

        let allBanks = TextManager.getBanks().map(a => {return {
            value: a.number,
            label: a.name
        }});

        let showID = false;
        if((providerId === 1 || providerId === 5 || providerId === 20) &&
            (environment.ListManagersFeatures.includes(this.props.userData.data.id) || this.props.userData.data.isAdmin || this.props.userData.data.id === 294)) {
            showID = true;
        }

        let hotSpecial = false;
        if(providerId === 1 || providerId === 20 || // && (environment.ListManagersFeatures.includes(this.props.userData.data.id) || this.props.userData.data.isAdmin)) {
            providerId === 5) { // or Walla
            hotSpecial = true;
        }

        let pelephonOrGolan = false;
        if(this.state.formFields.providerId === 4 || this.state.formFields.providerId === 9 || this.state.formFields.providerId === 25 || this.state.formFields.providerId === 28) {
            pelephonOrGolan = true;
        }

        return(
            <div className="form__form-group">
                <div className="form__form-group">
                    <div className="form__form-group-field" style={{flexDirection: "column"}}>
                        <Row style={{flexDirection: "row-reverse"}}>

                            <Col md={3} xs={12}>
                                <label className="form__form-group-label">
                                    {TextManager.getCurrentTextResource().Sales.salesItem.customerName}
                                </label>
                                <div className="form__form-group-field">
                                    <input name="customerName"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.customerName}
                                           type="text"
                                           dir={"auto"}
                                           onChange={(event) =>
                                               this.formFieldValueChanged('customerName', event.target.value)}
                                    />
                                </div>
                            </Col>

                            <Col md={2} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.id}</label>
                                <div className="form__form-group-field">
                                    <input
                                        //format="#########"
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.id}
                                        name="id"
                                        onBlur={() => this.passportLoseFocus(isStore)}
                                        type="text"
                                        onChange={(event) =>
                                            this.formFieldValueChanged('id', event.target.value)}
                                    />
                                </div>
                                {isNew && <Button
                                    color='primary'
                                    size='sm'
                                    style={{
                                        whiteSpace: 'normal',
                                        fontSize: '12px',
                                        marginTop: '30px'
                                    }}
                                    disabled={!this.state.isDataToImport}
                                    onClick={(e) => {
                                        this.getImport()
                                    }}>?האם לייבא</Button>}
                            </Col>

                            <Col md={3} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.address}</label>
                                <div className="form__form-group-field">
                                    <input
                                        dir={"auto"}
                                        style={{
                                            backgroundColor: '#DCDCDC'
                                        }}
                                        value={this.state.formFields.address}
                                        name="address"
                                        type="text"
                                        disabled
                                        onChange={(event) =>
                                            this.formFieldValueChanged('address', event.target.value)}
                                    />
                                </div>
                            </Col>

                            <Col md={2} xs={12}>
                                <span style={{display: "inline-block", height: 50}}></span>
                                <img src={logoUrl} style={{
                                    maxWidth: '190px',
                                    maxHeight: '190px',
                                    objectFit: 'contain'
                                }}/>
                            </Col>
                            <Col md={2} xs={12}>
                                <Button color='primary' size='sm' style={{
                                    whiteSpace: 'normal',
                                    fontSize: '12px',
                                    marginTop: '30px'
                                }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            window.open(provider.link, '_blank');
                                        }}>{provider.link_text}</Button>
                            </Col>
                        </Row>

                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col md={3} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.city}</label>
                                <div className="form__form-group-field">
                                    {this.state.formFields.city === undefined && this.state.formFields.cityName !== "" ? <input
                                        name='select'
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.cityName}
                                        disabled={true}
                                    >
                                    </input> : <Select
                                            name='select'
                                            style={{backgroundColor: '#F0F8FF'}}
                                            value={this.state.formFields.city}
                                            type={"select"}
                                            select
                                            options={allCities}
                                            onChange={(value) => this.formFieldValueChanged('city',  value.value, value.label)}
                                        >
                                        </Select>}
                                </div>
                            </Col>
                            <Col md={3} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.street}</label>
                                <div className="form__form-group-field">
                                    {this.state.formFields.street === undefined && this.state.formFields.streetName !== "" ? <input
                                        name='select'
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.streetName}
                                        disabled={true}
                                    >
                                    </input> : <Select
                                            name='select'
                                            style={{backgroundColor: '#F0F8FF'}}
                                            value={this.state.formFields.street}
                                            type={"select"}
                                            select
                                            options={allStreets}
                                            onChange={(value) => this.formFieldValueChanged('street',  value.value, value.label)}
                                        >
                                        </Select>}
                                </div>
                            </Col>
                            <Col md={2} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.number}</label>
                                <div className="form__form-group-field">
                                    <input
                                        dir={"auto"}
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.number}
                                        name="number"
                                        type="text"
                                        onChange={(event) =>
                                            this.formFieldValueChanged('number', event.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={2} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.flat}</label>
                                <div className="form__form-group-field">
                                    <input
                                        dir={"auto"}
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.flat}
                                        name="flat"
                                        type="text"
                                        onChange={(event) =>
                                            this.formFieldValueChanged('flat', event.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={2} xs={12}>
                                <label
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.floor}</label>
                                <div className="form__form-group-field">
                                    <input
                                        dir={"auto"}
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.floor}
                                        name="address"
                                        type="text"
                                        onChange={(event) =>
                                            this.formFieldValueChanged('floor', event.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        {!isNew && <div className='form__form-group'>
                            <div className="form__form-group-field"
                                 style={{flexDirection: "column"}}>
                                <Row style={{flexDirection: "row-reverse"}}>
                                    <Col md={2} xs={12}>
                                        <Button color='primary' size='sm' style={{
                                            whiteSpace: 'normal',
                                            fontSize: '12px',
                                            marginTop: '30px'
                                        }}
                                                onClick={(e) => {
                                                    this.setState({showChangeProvider: !this.state.showChangeProvider})
                                                }}>
                                            שינוי ספק
                                        </Button>
                                    </Col>

                                    {(isManager || isAdmin) && <Col md={2} xs={12}>
                                        <Button color='primary' size='sm' style={{
                                            whiteSpace: 'normal',
                                            fontSize: '12px',
                                            marginTop: '30px'
                                        }}
                                                onClick={(e) => {
                                                    this.setState({showChangeStore: !this.state.showChangeStore})
                                                }}>
                                            שינוי חנות
                                        </Button>
                                    </Col>}

                                    {(isSendTashvu && isCellcom && !isNew) && <Col md={2} xs={12}>
                                        <Button color='primary' size='sm' style={{
                                            whiteSpace: 'normal',
                                            fontSize: '12px',
                                            marginTop: '30px'
                                        }}
                                                onClick={(e) => this.sendToTashvuLi()}>
                                            לשלוח לתשוו לי
                                        </Button>
                                    </Col>}
                                </Row>
                                {this.state.showChangeProvider &&
                                <Row style={{flexDirection: "row-reverse"}}>
                                    <Col md={2} xs={12}>
                                        <label
                                            className='form__form-group-label'>ספק</label>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            //disabled={!(this.props.userData.data.isManager || this.props.userData.data.isAdmin)}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.providerId}
                                            type={"select"}
                                            select
                                            options={allProviders}
                                            onChange={(event) => {
                                                this.changeProvider(event.value)
                                            }}>
                                        </Select>
                                    </Col>
                                </Row>}
                                {this.state.showChangeStore &&
                                <Row style={{flexDirection: "row-reverse"}}>
                                    <Col md={2} xs={12}>
                                        <label
                                            className='form__form-group-label'>חנות</label>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            //disabled={!(this.props.userData.data.isManager || this.props.userData.data.isAdmin)}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.storeId}
                                            type={"select"}
                                            select
                                            options={stores}
                                            onChange={(event) => {
                                                this.changeStore(event.value)
                                            }}>
                                        </Select>
                                    </Col>
                                </Row>}
                            </div>
                        </div>}
                    </div>
                </div>

                {this.state.formFields.dealType === 1 && <div className="form__form-group">
                    {isKosher && <h1 style={{textAlign: 'center'}}>{this.getKasherText()}</h1>}
                    {likeKosher && <h1 style={{textAlign: 'center'}}>{this.getHotRegularText()}</h1>}
                    {this.state.formFields.lines.map((line, index) => {
                        return <Row style={{flexDirection: "row-reverse"}} key={index}>
                            {(!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)) &&
                            <Col sm={6} lg={showID ? 2 : 4} md={showID ? 2 : 4}>
                                <Row style={{flexDirection: "row-reverse"}} key={index}>
                                <Col sm={6} lg={5} md={5}>
                                    <div className={"cellular-div"}>
                                        <span
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.tempSimNumber}</span>
                                        <div className='form__form-group-field'>
                                            <Select
                                                style={pelephonOrGolan ? {
                                                    cursor: 'pointer',
                                                    backgroundColor: '#DCDCDC',
                                                    width: '100%'
                                                } : {
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                name='select'
                                                disabled={pelephonOrGolan || line.isNewNumber === 0}
                                                value={line.isTempNumber}
                                                type={"select"}
                                                select
                                                options={transferQuestionOptions}
                                                onChange={(value) => this.linesChanged("update", index, "isTempNumber", value.value)}>
                                            </Select>

                                        </div>
                                    </div>
                                </Col>
                                <Col sm={6} lg={7} md={7}>
                                    <div className={"cellular-div"}>
                                        <span
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.tempSimNumber}</span>
                                        <div className='form__form-group-field'>
                                            <NumberFormat
                                                format="##########"
                                                value={line.tempSimNumber}
                                                style={line.isTempNumber === 0 ? {
                                                        backgroundColor: '#DCDCDC',
                                                        width: '100%'
                                                    } :
                                                    {backgroundColor: '#F0F8FF', width: '100%'}}
                                                name="tempSimNumber"
                                                dir={"auto"}
                                                disabled={(line.isTempNumber === 0)}
                                                onChange={(event) =>
                                                    this.linesChanged("update", index, "tempSimNumber", event.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                </Row>
                            </Col>}

                            {isNew &&
                            <Col sm={6} lg={1} md={1}>
                                <div className={"cellular-div"}>
                                    <span className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.givenNumberQuestionOnAdd}</span>
                                    <div className='form__form-group-field'>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            name='select'
                                            value={line.isNewNumber}
                                            type={"select"}
                                            select
                                            options={transferQuestionOptionsOnAdd}
                                            onChange={(value) => this.linesChanged("update", index, "isNewNumber", value.value)}>
                                        </Select>
                                    </div>
                                </div>
                            </Col>}

                            <Col sm={6} lg={2} md={2}>
                                <div className={"cellular-div"}>
                                    <span className="form__form-group-label">
                                        {TextManager.getCurrentTextResource().Sales.salesItem.customerNumber}
                                    </span>
                                    <input
                                        //format="##########"
                                        value={line.customerNumber}
                                        style={line.isNewNumber === 0 ? {
                                                backgroundColor: '#DCDCDC',
                                                width: '100%'
                                            } :
                                            {backgroundColor: '#F0F8FF', width: '100%'}}
                                        name="customerNumber"
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        dir={"auto"}
                                        disabled={((!isNew && line.isNewNumber === 0 && isStore) || (isNew && line.isNewNumber === 0))}
                                        onChange={(event) =>
                                            this.linesChanged("update", index, "customerNumber", event.target.value)}
                                    />
                                </div>
                            </Col>

                            {isNew &&
                            <Col sm={6} lg={1} md={1}>
                                <div className={"cellular-div"}>
                                    <span className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.isSimOrSend}</span>
                                    <div className='form__form-group-field'>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            name='select'
                                            value={line.isSimOrSend}
                                            type={"select"}
                                            select
                                            onBlur={() => this.isSimOrSendLoseFocus(line.isSimOrSend)}
                                            options={simOrSend}
                                            onChange={(value) => this.linesChanged("update", index, "isSimOrSend", value.value)}>
                                        </Select>
                                    </div>
                                </div>
                            </Col>}

                            <Col sm={6} lg={2} md={3}>
                                <div className={"cellular-div"}>
                                    <span className="form__form-group-label">
                                        {TextManager.getCurrentTextResource().Sales.salesItem.simNumber}
                                    </span>
                                    <NumberFormat
                                        //format="##########"
                                        value={line.simNumber}
                                        style={(line.isSimOrSend === 0 || line.isSimOrSend === undefined) ? {
                                                backgroundColor: '#DCDCDC',
                                                width: '100%'
                                            } : (line.isSimOrSend === 2) ? {backgroundColor: '#70bbfd', width: '100%'} :
                                            {backgroundColor: '#F0F8FF', width: '100%'}}
                                        name="simNumber"
                                        dir={"auto"}
                                        disabled={(line.isSimOrSend === 0 || line.isSimOrSend === 2 || line.isSimOrSend === undefined)}
                                        onChange={(event) =>
                                            this.linesChanged("update", index, "simNumber", event.target.value)}
                                    />
                                    {!isNew && (isManager || isAdmin) && line.isSimOrSend === 2 &&
                                        <i className="fa fa-file-text-o" style={{ fontSize: '20px', marginRight: '5px', marginTop: '5px', cursor: 'pointer'}}
                                           onClick={(e) =>
                                           {
                                               e.stopPropagation();
                                               this.isSimOrSendLoseFocus(2)}
                                           }></i>}
                                </div>
                            </Col>
                            <Col sm={6} lg={2} md={3}>
                                <div className={"cellular-div"}>
                                    <span
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.deal}</span>
                                    <div className='form__form-group-field'>
                                        {(isNew || (!isNew && (this.props.userData.data.isManager ||
                                            this.props.userData.data.isAdmin || this.state.wasProviderChanged))) &&
                                        <Select
                                            id={"PopoverTop"+index}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            name='select'
                                            value={line.deal.text}
                                            type={"select"}
                                            select
                                            options={this.props.dealsList.map(d => {
                                                return {
                                                    label: d.text,
                                                    value: d.text,
                                                    amount: d.amount,
                                                    tashvuId: d.tashvuId,
                                                    comment: d.comment,
                                                    autoId: d.autoId
                                                }
                                            })}
                                            onChange={(value) => this.dealChanged(index, value)}>
                                        </Select>}

                                        {(isNew || (!isNew && (this.props.userData.data.isManager ||
                                            this.props.userData.data.isAdmin || this.state.wasProviderChanged))) &&
                                            <div>
                                                <style>
                                                 {`
                                                    .popover {
                                                    max-width: 300px;
                                                    }
                                                `}
                                                </style>
                                                <Popover
                                                    placement="bottom"
                                                    isOpen={this.state.popoverOpen === index}
                                                    target={"PopoverTop"+index}
                                                    toggle={() => this.togglePopover(-1)}
                                                >
                                                    <PopoverHeader className='bold-text'>:לידיעה המסלול כולל</PopoverHeader>
                                                    <PopoverBody>
                                                        <Textarea
                                                            disabled
                                                            value={line.deal.comment}
                                                            name="PopoverTop_comment"
                                                            onChange={(event) =>
                                                                this.props.dispatch(provider_deal_changed('comment', event.target.value, index))}
                                                        />
                                                    </PopoverBody>
                                                    <p onClick={() => this.togglePopover(-1)}
                                                       style={{fontWeight: 'bold', color: '#1ABB10', textDecoration: 'underline', cursor: 'pointer',
                                                           margin: 0, textAlign: 'right', paddingRight: '10px'}}> ✔️הבנתי
                                                    </p>
                                                </Popover>
                                            </div>}

                                        {!isNew && !this.props.userData.data.isManager && !this.props.userData.data.isAdmin &&
                                        !this.state.wasProviderChanged &&
                                        <input
                                            value={line.deal.text}
                                            dir={"auto"}
                                            name="amount"
                                            type="text"
                                            disabled={true}
                                            style={{
                                                backgroundColor: '#DCDCDC',
                                                width: '100%'
                                            }}/>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col sm={6} lg={2} md={2}>
                                <div className={"cellular-div"}>
                                    <span
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.price}
                                    </span>
                                    <div className='form__form-group-field'>
                                        <input
                                            value={line.deal.amount}
                                            dir={"auto"}
                                            name="amount"
                                            type="text"
                                            disabled={true}
                                            style={{
                                                backgroundColor: '#DCDCDC',
                                                width: '100%'
                                            }}/>
                                    </div>
                                </div>
                            </Col>

                            {!isNew && showID &&
                            <Col sm={6} lg={2} md={2}>
                                <div className={"cellular-div"}>
                                    <span className="form__form-group-label">
                                        ייחודי ID
                                    </span>
                                    <div className="form__form-group-field">
                                        <input name="customerName"
                                               style={{backgroundColor: '#F0F8FF'}}
                                               value={line.uniqueId}
                                               dir={"auto"}
                                               onChange={(event) =>
                                                   this.linesChanged("update", index,'uniqueId', event.target.value)}
                                        />
                                    </div>
                                </div>
                            </Col>}

                            {isNew && index > 0 && <Col sm={6} lg={1} style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            }}>
                                <div style={{padding: "20px 10px"}}>
                                    <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                       onClick={
                                           (event) =>
                                               this.linesChanged("delete", index)
                                       }> </i>
                                </div>
                            </Col>
                            }
                            {isNew && index === 0 && <Col sm={6} lg={1} style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            }}>
                                <div style={{padding: "20px 10px"}}
                                     className={"cellular-div"}>

                                </div>
                            </Col>
                            }

                            {!isNew && <Col sm={6} lg={2} md={2}>
                                <div className={"cellular-div"}>
                                    <span
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.status}
                                    </span>
                                    <div className='form__form-group-field'>
                                        <Button
                                            color={this.getLineStatusColor(line.status)}
                                            size='sm'
                                            style={{
                                                marginRight: '-10px',
                                                fontSize: '12px',
                                            }}
                                            onClick={() => this.changeLineStatus('status', index)}>{this.getLineStatusText(line.status)}
                                        </Button>
                                        {index > 0 && <div style={{padding: "10px 10px"}}
                                                           className={"cellular-div"}>
                                            <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                               onClick={
                                                   (event) =>
                                                       this.linesChanged("delete", index)
                                               }> </i>
                                        </div>}
                                    </div>
                                </div>
                            </Col>}

                            {isNew && <Col></Col>}

                            {isNew && <Col></Col>}

                            {this.checkIVR(providerId, line.customerNumber) && <Col sm={6} lg={2}>
                                <div className={"cellular-div"}>
                                    <span
                                        className='form__form-group-label'>{"IVR שליחת שיחת"}
                                    </span>
                                    <div className='form__form-group-field'>
                                        <Button
                                            color={"primary"}
                                            size='sm'
                                            style={{
                                                marginRight: '-10px',
                                                fontSize: '12px',
                                            }}
                                            onClick={() => this.sendIVR(providerId, line.customerNumber)}>{"לשלוח"}
                                        </Button>
                                    </div>
                                </div>
                            </Col>}

                        </Row>
                    })}
                    {isNew && <div style={{textAlign: 'right', marginTop: '10px'}}>
                        <Button color="primary"
                                onClick={this.addLine}>{TextManager.getCurrentTextResource().Sales.salesItem.addLine}</Button>
                    </div>}
                    <Row style={{flexDirection: "row-reverse"}}>
                        <Col lg={3} md={6} xs={12}>
                            <div>
                                <label className="form__form-group-label">
                                    יצירת קשר (ספרות בלבד)
                                </label>
                                <div className='form__form-group-field'
                                     style={{maxWidth: "none"}}>
                                    <input
                                        value={this.state.formFields.contact}
                                        style={{backgroundColor: '#F0F8FF',}}
                                        name="contact"
                                        dir={"auto"}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        onChange={(event) =>
                                            this.formFieldValueChanged('contact', event.target.value)}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} md={6} xs={12}>
                            <div>
                                <label className="form__form-group-label">
                                    מייל
                                </label>
                                <div className='form__form-group-field'
                                     style={{maxWidth: "none"}}>
                                    <input
                                        value={this.state.formFields.mail}
                                        type="text"
                                        style={{backgroundColor: '#F0F8FF',}}
                                        name="mail"
                                        dir={"auto"}
                                        onChange={(event) =>
                                            this.formFieldValueChanged('mail', event.target.value)}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>}

                {this.state.formFields.dealType === 2 && <div className="form__form-group">
                    <div className="form__form-group-field" style={{flexDirection: "column"}}>
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={3} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    מספר טלפון ליצירת קשר
                                </label>
                                <div className="form__form-group-field">
                                    <input name="phoneNumber"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.tv.phoneNumber}
                                           dir={"auto"}
                                           onChange={(event) =>
                                               this.dynamicFieldChanged('phoneNumber', event.target.value)}
                                    />
                                </div>
                            </Col>

                            <Col md={3} xs={4}>
                                <label className="form__form-group-label">
                                    מייל
                                </label>
                                <div className="form__form-group-field">
                                    <input name="mail"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.tv.mail}
                                           dir={"auto"}
                                           disabled={!(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)))}
                                           onChange={(event) =>
                                               this.dynamicFieldChanged('mail', event.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row style={{flexDirection: "row-reverse"}}>

                            <Col lg={2} md={6} xs={12}>
                                <div>
                                    <label
                                        className='form__form-group-label'>סוג עסקה</label>
                                    <div className='form__form-group-field'>
                                        {(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin))) &&
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.tvInternetDealType}
                                            type={"select"}
                                            select
                                            options={tvFiled.map((d, index) => {
                                                return {
                                                    label: d,
                                                    value: index
                                                }
                                            })}
                                            onChange={(event) =>
                                                this.setState({tvInternetDealType: event.value})}>
                                        </Select>}

                                    </div>
                                </div>
                            </Col>

                            <Col lg={4} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    פ.ט. מסלול
                                </label>
                                <div className='form__form-group-field'>
                                    {(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin))) &&
                                    <Select
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#F0F8FF',
                                            width: '100%'
                                        }}
                                        rtl={true}
                                        name='select'
                                        value={this.state.formFields.tv.deal}
                                        type={"select"}
                                        select
                                        options={tvDealOption.map((d, index) => {
                                            return {
                                                label: d.text,
                                                value: d.text,
                                                amount: d.amount
                                            }
                                        })}
                                        onChange={(event) =>
                                            this.dynamicFieldChanged('deal', event.value, "tv")}>
                                    </Select>}

                                </div>
                            </Col>

                        </Row>

                        <Row style={{flexDirection: "row-reverse"}}>

                            <Col lg={2} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    ראוטר
                                </label>
                                <div className="form__form-group-field">
                                    <Select
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#F0F8FF',
                                            width: '100%'
                                        }}
                                        rtl={true}
                                        name='select'
                                        value={this.state.formFields.tv.router}
                                        type={"select"}
                                        select
                                        options={yesNo.map((d, index) => {
                                            return {
                                                label: d.label,
                                                value: d.label
                                            }
                                        })}
                                        onChange={(event) =>
                                            this.dynamicFieldChanged('router', event.value, "tv")}>
                                    </Select>
                                </div>
                            </Col>

                            <Col lg={2} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    מספר ממירים
                                </label>
                                <div className="form__form-group-field">
                                    <input name="numberOfConvertors"
                                           type={"number"}
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.tv.numberOfConvertors}
                                           disabled={!(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)))}
                                           min={0}
                                           max={8}
                                           dir={"auto"}
                                           onChange={(event) =>
                                               this.dynamicFieldChanged('numberOfConvertors', event.target.value)}
                                    />
                                </div>
                            </Col>

                            {!isNew && <Col md={3} xs={4}>
                                <div>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.status}
                                    </label>
                                    <div className='form__form-group-field'>

                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.status}
                                            type={"select"}
                                            select
                                            options={dealsStatusTypes}
                                            onChange={(event) => this.formFieldValueChanged('status', event.value)}>
                                        </Select>
                                    </div>
                                </div>
                            </Col>}

                        </Row>
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col md={9} xs={4}>
                                <label className="form__form-group-label">
                                    פרטי מבצע
                                </label>
                                <div className="form__form-group-field">
                                    <textarea name="mail"
                                              style={{backgroundColor: '#F0F8FF'}}
                                              value={this.state.formFields.tv.executorDetails}
                                              disabled={!(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)))}

                                              dir={"auto"}
                                              onChange={(event) =>
                                                  this.dynamicFieldChanged('executorDetails', event.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>}

                {this.state.formFields.dealType === 3 && <div className="form__form-group">
                    <div className="form__form-group-field" style={{flexDirection: "column"}}>
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={3} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    מספר טלפון ליצירת קשר
                                </label>
                                <div className="form__form-group-field">
                                    <input name="phoneNumber"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.internet.phoneNumber}
                                           dir={"auto"}
                                           onChange={(event) =>
                                               this.dynamicFieldChanged('phoneNumber', event.target.value, "internet")}
                                    />
                                </div>
                            </Col>

                            <Col lg={3} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    מייל
                                </label>
                                <div className="form__form-group-field">

                                    <input name="mail"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.internet.mail}
                                           dir={"auto"}
                                           disabled={!(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)))}
                                           onChange={(event) =>
                                               this.dynamicFieldChanged('mail', event.target.value, "internet")}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={2} md={6} xs={12}>
                                <div>
                                    <label
                                        className='form__form-group-label'>סוג עסקה</label>
                                    <div className='form__form-group-field'>
                                        {(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin))) &&
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.tvInternetDealType}
                                            type={"select"}
                                            select
                                            options={bezekHotRestOption.map((d, index) => {
                                                return {
                                                    label: d,
                                                    value: index
                                                }
                                            })}
                                            onChange={(event) =>
                                                this.setState({tvInternetDealType: event.value})}>
                                        </Select>}

                                    </div>
                                </div>
                            </Col>

                            <Col lg={4} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    פ.ט. מסלול
                                </label>
                                <div className="form__form-group-field">
                                    {(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin))) &&
                                    <Select
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#F0F8FF',
                                            width: '100%'
                                        }}
                                        rtl={true}
                                        name='select'
                                        value={this.state.formFields.internet.deal}
                                        type={"select"}
                                        select
                                        options={internetDealOption.map((d, index) => {
                                            return {
                                                label: d.text,
                                                value: d.text,
                                                amount: d.amount
                                            }
                                        })}
                                        onChange={(event) =>
                                            this.dynamicFieldChanged('deal', event.value, "internet")}>
                                    </Select>}
                                </div>
                            </Col>

                        </Row>

                        <Row style={{flexDirection: "row-reverse"}}>

                            <Col lg={2} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    ראוטר
                                </label>
                                <div className="form__form-group-field">
                                    <Select
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#F0F8FF',
                                            width: '100%'
                                        }}
                                        rtl={true}
                                        name='select'
                                        value={this.state.formFields.internet.routerCost}
                                        type={"select"}
                                        select
                                        options={yesNo.map((d, index) => {
                                            return {
                                                label: d.label,
                                                value: d.label
                                            }
                                        })}
                                        onChange={(event) =>
                                            this.dynamicFieldChanged('routerCost', event.value, "internet")}>
                                    </Select>
                                </div>
                            </Col>

                            <Col lg={2} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    עלות התקנה/משלוח
                                </label>
                                <div className="form__form-group-field">
                                    <input name="mail"
                                           type={"number"}
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.internet.shipmentCost}
                                           dir={"auto"}
                                           disabled={!(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)))}
                                           onChange={(event) =>
                                               this.dynamicFieldChanged('shipmentCost', event.target.value, "internet")}
                                    />
                                </div>
                            </Col>
                            {!isNew && <Col lg={4} md={6} xs={12}>
                                <div>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.status}
                                    </label>
                                    <div className='form__form-group-field'>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.status}
                                            type={"select"}
                                            select
                                            options={dealsStatusTypes}
                                            onChange={(event) => this.formFieldValueChanged('status', event.value)}>
                                        </Select>
                                    </div>
                                </div>
                            </Col>}

                        </Row>

                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col md={9} xs={12}>
                                <label className="form__form-group-label">
                                    פרטי מבצע
                                </label>
                                <div className="form__form-group-field">
                                <textarea name="mail"
                                          style={{backgroundColor: '#F0F8FF'}}
                                          value={this.state.formFields.internet.executorDetails}
                                          dir={"auto"}
                                          disabled={!(isNew || (!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)))}
                                          onChange={(event) =>
                                              this.dynamicFieldChanged('executorDetails', event.target.value, "internet")}
                                />
                                </div>
                            </Col>

                        </Row>
                    </div>
                </div>}

                <div className="form__form-group">
                    <div className="form__form-group-field" style={{flexDirection: "column"}}>

                        {!isNew && this.state.formFields.lines && this.state.formFields.lines.length > 0 &&
                        (this.props.userData.data.isManager || this.props.userData.data.isAdmin) &&
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={3} md={6} xs={12}>
                                <div>
                                    <label className="form__form-group-label">
                                        שם משווק:
                                    </label>
                                    <div className='form__form-group-field'
                                         style={{maxWidth: "none"}}>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.lines[0].handleName}
                                            type={"select"}
                                            select
                                            options={handleName}
                                            onChange={(event) =>
                                                this.linesChanged("update", 0, "handleName", event.value)}/>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={6} xs={12}>
                                <div>
                                    <label className="form__form-group-label">
                                        שם משווק ישן:
                                    </label>
                                    <div className='form__form-group-field'
                                         style={{maxWidth: "none"}}>
                                        <input
                                            value={this.state.formFields.lines[0].notes}
                                            type="text"
                                            style={{backgroundColor: '#DCDCDC',}}
                                            name="customerNumber"
                                            dir={"auto"}
                                            disabled
                                            onChange={(event) =>
                                                this.linesChanged("update", 0, "notes", event.target.value)}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>}

                        {isStoreHandleName && <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={3} md={6} xs={12}>
                                <div>
                                    <label className="form__form-group-label">
                                        שם משווק:
                                    </label>
                                    <div className='form__form-group-field'
                                         style={{maxWidth: "none"}}>
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.lines[0].handleName}
                                            type={"select"}
                                            select
                                            options={handleName}
                                            onChange={(event) =>
                                                this.linesChanged("update", 0, "handleName", event.value)}/>
                                    </div>
                                </div>
                            </Col>
                        </Row>}

                        {isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin) &&
                        <Row style={{flexDirection: "row-reverse"}}>

                            <Col lg={3} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    שם חנות
                                </label>
                                <div className="form__form-group-field">
                                    <Select
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#F0F8FF',
                                            width: '100%'
                                        }}
                                        rtl={true}
                                        name='select'
                                        value={this.state.formFields.storeId}
                                        type={"select"}
                                        select
                                        options={stores}
                                        onChange={(event) => {
                                            let updatedFormFields = {...this.state.formFields};
                                            updatedFormFields.storeId = event.value;
                                            this.setState({formFields: updatedFormFields});
                                        }}>
                                    </Select>
                                </div>
                            </Col>
                        </Row>}

                        <Row style={{flexDirection: "row-reverse"}}>

                            <Col lg={3} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    {TextManager.getCurrentTextResource().Sales.salesItem.customerNumberId}
                                </label>
                                <div className="form__form-group-field">
                                    <input name="customerName"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.customerId}
                                           dir={"auto"}
                                           onChange={(event) =>
                                               this.formFieldValueChanged('customerId', event.target.value)}
                                    />
                                </div>
                            </Col>

                            {this.state.formFields.dealType === 1 && !isNew && hotSpecial &&
                            <Col lg={3} md={6} xs={12}>
                                <div className={"cellular-div"}>
                                    <label className="form__form-group-label">
                                        מספר הזמנה
                                    </label>
                                    <div className="form__form-group-field">
                                        <input name="customerName"
                                               style={{backgroundColor: '#F0F8FF'}}
                                               value={this.state.formFields.lines[0].orderNum}
                                               dir={"auto"}
                                               onChange={(event) =>
                                                   this.linesChanged("update", 0,'orderNum', event.target.value)}
                                        />
                                    </div>
                                </div>
                            </Col>}


                        </Row>

                        {/* Only for Bezek */}
                        {providerId === 15 && <Row style={{flexDirection: "row-reverse"}}>

                            <Col lg={3} md={6} xs={12}>
                                <label className="form__form-group-label">
                                    מספר מוקצה
                                </label>
                                <div className="form__form-group-field">
                                    <input name="customerName"
                                           style={{backgroundColor: '#F0F8FF'}}
                                           value={this.state.formFields.given_number}
                                           dir={"auto"}
                                           onChange={(event) =>
                                               this.formFieldValueChanged('given_number', event.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>}

                        {this.props.userData.data.isAdmin &&
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={3} md={6} xs={12}>
                                <div className="form__form-group" dir="rtl">
                                    <span className="form__form-group-label"
                                          style={{fontWeight: 'bold'}}>הערות אישיות לדנה</span>
                                    <div>
                                        <textarea
                                            style={{backgroundColor: '#F0F8FF'}}
                                            value={this.state.formFields.admin_comment}
                                            name="admin_comment"
                                            onChange={(event) =>
                                                this.formFieldValueChanged('admin_comment', event.target.value)}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>}
                    </div>
                </div>

                {isNew &&
                <div className="form__form-group">
                    <div className="form__form-group-field">
                        <Row>
                            <Col sm={12}>
                                {!this.state.selfDealCheck && this.state.selfDeal && <ModalTrue2 color='danger' title='האם אתה בטוח?'
                                       ok='כן אני בטוח'
                                       cancel='ביטול'
                                       approve={() => this.setState({selfDealCheck: true})}
                                       decline={() => this.setState({selfDeal: false})}
                                       message={'האם אתה בטוח שהעסקה כבר טופלה ואינך צריך שצוות התפעול יטפל בעסקה?'}>
                                </ModalTrue2>}
                                <CheckBox
                                    name='selfDeal'
                                    label='הוקם עצמאית במערכת'
                                    value={this.state.selfDeal}
                                    onChange={(e) => this.setState({selfDeal: e})}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                }

                <div className="form__form-group">
                    <span className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.paymentMethod}</span>
                    <div className={"radio-button__group"}>
                        <RadioButtonField name="credit" value={"credit"}
                                          label={TextManager.getCurrentTextResource().Sales.salesItem.creditCard}
                                          onChange={(value) => {
                                              this.formFieldValueChanged('paymentMethod', 'credit');
                                          }}
                                          radioValue={this.state.formFields.paymentMethod}/>
                        <RadioButtonField name="bank" value={"bank"}
                                          onChange={(value) => {
                                              this.formFieldValueChanged('paymentMethod', 'bank');

                                          }}
                                          label={TextManager.getCurrentTextResource().Sales.salesItem.directDebit}
                                          radioValue={this.state.formFields.paymentMethod}/>
                    </div>

                </div>

                {this.state.formFields.paymentMethod === "credit" &&
                <div className="form__form-group">
                    {isDirect && <Row style={{flexDirection: 'row-reverse'}}>
                        <Alert color='warning' className='alert--bordered' icon>
                            <p><span className='bold-text'>שים לב ❤️ זה כרטיס דיירקט</span></p>
                        </Alert>
                    </Row>}
                    <Row style={{flexDirection: 'row-reverse'}}>

                        <Col sm={4}>
                            <span
                                className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cardNumber}</span>
                            <div className="form__form-group-field" style={this.state.cardValidWarning === '' ? {} : {border: '2px solid red'}}>
                                <NumberFormat
                                    //format="#### #### #### ####"
                                    format="################"
                                    style={{backgroundColor: '#F0F8FF'}}
                                    //value={this.state.formFields.paymentDetails.cardNumber || ''}
                                    value={cardNumber}
                                    name="cardNumber"
                                    onFocus={() => this.cardFocusChanged("cardNumber")}
                                    placeholder="0000 0000 0000 0000"
                                    type="text"
                                    onChange={(event) => {
                                        this.paymentDetailsChanged('cardNumber', event.target.value);
                                    }
                                    }
                                />
                            </div>
                            {this.state.cardValidWarning !== '' && <div><span style={{fontWeight: 'bold', color: 'red'}}
                                                                         className="form__form-group-label">{this.state.cardValidWarning}</span></div>}
                            <span
                                className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.validationDate}</span>
                            <div className="form__form-group-field">
                                <NumberFormat
                                    format={this.cardExpiry}
                                    style={{backgroundColor: '#F0F8FF'}}
                                    value={this.state.formFields.paymentDetails.validationDate || ""}
                                    name="validationDate"
                                    required
                                    onFocus={() => this.cardFocusChanged("validationDate")}
                                    placeholder="MM/YY"
                                    data-valid-example="05/18"
                                    onChange={(event) =>
                                        this.paymentDetailsChanged('validationDate', event.target.value)}
                                />
                            </div>
                            <span
                                className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cvv}</span>
                            <div className="form__form-group-field">
                                <input
                                    dir={"auto"}
                                    //value={this.state.formFields.paymentDetails.cvv || ''}
                                    value={cvv}
                                    style={{backgroundColor: '#F0F8FF'}}
                                    name="cvv"
                                    minLength={(this.state.formFields.paymentDetails.cardType === "mastercard"
                                        || this.state.formFields.paymentDetails.cardType === "visa") ? 3 : 4}
                                    maxLength={this.state.formFields.paymentDetails.cardType === "mastercard"
                                    || this.state.formFields.paymentDetails.cardType === "visa" ? 3 : 4}
                                    type="text"
                                    autoComplete={"on"}
                                    required
                                    onFocus={() => this.cardFocusChanged("cvv")}
                                    onChange={(event) =>
                                        this.paymentDetailsChanged('cvv', event.target.value)}
                                />
                            </div>
                        </Col>

                        <Col sm={3}>
                            <div className="form__form-group-field">
                                <Cards style={{margin: 'none'}}
                                       preview={true}
                                    //number={this.state.formFields.paymentDetails.cardNumber}
                                       number={cardNumber}
                                       name={""}
                                       expiry={this.state.formFields.paymentDetails.validationDate || ""}
                                    //cvc={this.state.formFields.paymentDetails.cvv}
                                       cvc={cvv}
                                       focused={this.state.cardFocus}
                                       placeholders={{
                                           name: ''
                                       }}
                                       callback={(event, isValid) =>
                                           this.paymentDetailsChanged('cardType', event.issuer)}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                }


                {this.state.formFields.paymentMethod === "bank" &&
                <div className="form__form-group">

                    <Row style={{flexDirection: "row-reverse"}}>
                        <Col md={3} xs={12}>
                            <label
                                className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bank}</label>
                            <div className="form__form-group-field">
                                <Select
                                    name='bank'
                                    style={{backgroundColor: '#F0F8FF'}}
                                    value={this.state.formFields.paymentDetails.bank}
                                    type={"select"}
                                    select
                                    options={allBanks}
                                    onChange={(value) => this.paymentDetailsChanged('bank',  value.value)}
                                >
                                </Select>
                            </div>
                        </Col>
                    </Row>


                    <Row style={{flexDirection: "row-reverse"}}>
                        <Col md={3} xs={12}>
                            <span className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bankAccountBranch}</span>
                            <div className="form__form-group-field">
                                <input
                                    dir={"auto"}
                                    value={this.state.formFields.paymentDetails.bankAccountBranch}
                                    name="bank"
                                    type="text"
                                    style={{backgroundColor: '#F0F8FF'}}
                                    onChange={(event) =>
                                        this.paymentDetailsChanged('bankAccountBranch', event.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row style={{flexDirection: "row-reverse"}}>
                        <Col md={3} xs={12}>
                            <span className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bankAccountNumber}</span>
                            <div className="form__form-group-field">
                                <input
                                    dir={"auto"}
                                    value={this.state.formFields.paymentDetails.bankAccountNumber}
                                    name="bank"
                                    type="text"
                                    style={{backgroundColor: '#F0F8FF'}}
                                    onChange={(event) =>
                                        this.paymentDetailsChanged('bankAccountNumber', event.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row style={{flexDirection: "row-reverse"}}>
                        <Col md={3} xs={12}>
                            <span className="form__form-group-label">מספר בנק</span>
                            <div className="form__form-group-field">
                                <input
                                    dir={"auto"}
                                    value={this.state.formFields.paymentDetails.bank}
                                    name="bank"
                                    type="text"
                                    disabled={true}
                                    style={{backgroundColor: '#DCDCDC'}}
                                    onChange={(event) =>
                                        this.paymentDetailsChanged('bank', event.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>

                </div>
                }
            </div>
        )
    };

    getWithImagePart = (isNew, logoUrl, provider, isManager, isAdmin, isSendTashvu, isCellcom,
                      allProviders, stores, isKosher, likeKosher, transferQuestionOptions,
                      transferQuestionOptionsOnAdd, isStore, tvDealOption, dealsStatusTypes,
                      bezekHotRestOption, internetDealOption, handleName, isStoreHandleName,
                      providerId, isDirect, cardNumber, cvv) => {
        return(
            <Row className="form__form-group">
                <Col md={6}>
                    <div className="form__form-group">
                        <div className="form__form-group-field" style={{flexDirection: "column"}}>
                            <Row style={{flexDirection: "row-reverse"}}>

                                <Col md={3} xs={12}>
                                    <label className="form__form-group-label">
                                        {TextManager.getCurrentTextResource().Sales.salesItem.customerName}
                                    </label>
                                    <div className="form__form-group-field">
                                        <input name="customerName"
                                               style={{backgroundColor: '#F0F8FF'}}
                                               value={this.state.formFields.customerName}
                                               type="text"
                                               dir={"auto"}
                                               onChange={(event) =>
                                                   this.formFieldValueChanged('customerName', event.target.value)}
                                        />
                                    </div>
                                </Col>

                                <Col md={2} xs={12}>
                                    <label
                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.id}</label>
                                    <div className="form__form-group-field">
                                        <NumberFormat
                                            //format="#########"
                                            style={{backgroundColor: '#F0F8FF'}}
                                            value={this.state.formFields.id}
                                            name="id"
                                            allowLeadingZeros={true}
                                            onBlur={() => this.passportLoseFocus(isStore)}
                                            onChange={(event) =>
                                                this.formFieldValueChanged('id', event.target.value)}
                                        />
                                    </div>
                                    {isNew && this.state.salesType === 1 && <Button
                                        color='primary'
                                        size='sm'
                                        style={{
                                            whiteSpace: 'normal',
                                            fontSize: '12px',
                                            marginTop: '30px'
                                        }}
                                        disabled={!this.state.isDataToImport}
                                        onClick={(e) => {
                                            this.getImport()
                                        }}>?האם לייבא</Button>}
                                </Col>

                                <Col md={3} xs={12}>
                                    <label
                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.address}</label>
                                    <div className="form__form-group-field">
                                        <input
                                            dir={"auto"}
                                            style={{backgroundColor: '#F0F8FF'}}
                                            value={this.state.formFields.address}
                                            name="address"
                                            type="text"
                                            onChange={(event) =>
                                                this.formFieldValueChanged('address', event.target.value)}
                                        />
                                    </div>
                                </Col>

                                <Col md={2} xs={12}>
                                    <span style={{display: "inline-block", height: 50}}></span>
                                    <img src={logoUrl} style={{
                                        maxWidth: '190px',
                                        maxHeight: '190px',
                                        objectFit: 'contain'
                                    }}/>
                                </Col>
                                <Col md={2} xs={12}>
                                    <Button color='primary' size='sm' style={{
                                        whiteSpace: 'normal',
                                        fontSize: '12px',
                                        marginTop: '30px'
                                    }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(provider.link, '_blank');
                                            }}>{provider.link_text}</Button>
                                </Col>

                            </Row>
                            {!isNew && <div className='form__form-group'>
                                <div className="form__form-group-field"
                                     style={{flexDirection: "column"}}>
                                    <Row style={{flexDirection: "row-reverse"}}>
                                        <Col md={2} xs={12}>
                                            <Button color='primary' size='sm' style={{
                                                whiteSpace: 'normal',
                                                fontSize: '12px',
                                                marginTop: '30px'
                                            }}
                                                    onClick={(e) => {
                                                        this.setState({showChangeProvider: !this.state.showChangeProvider})
                                                    }}>
                                                שינוי ספק
                                            </Button>
                                        </Col>

                                        {(isManager || isAdmin) && <Col md={2} xs={12}>
                                            <Button color='primary' size='sm' style={{
                                                whiteSpace: 'normal',
                                                fontSize: '12px',
                                                marginTop: '30px'
                                            }}
                                                    onClick={(e) => {
                                                        this.setState({showChangeStore: !this.state.showChangeStore})
                                                    }}>
                                                שינוי חנות
                                            </Button>
                                        </Col>}

                                        {(isSendTashvu && isCellcom && !isNew) && <Col md={2} xs={12}>
                                            <Button color='primary' size='sm' style={{
                                                whiteSpace: 'normal',
                                                fontSize: '12px',
                                                marginTop: '30px'
                                            }}
                                                    onClick={(e) => this.sendToTashvuLi()}>
                                                לשלוח לתשוו לי
                                            </Button>
                                        </Col>}
                                    </Row>
                                    {this.state.showChangeProvider &&
                                    <Row style={{flexDirection: "row-reverse"}}>
                                        <Col md={2} xs={12}>
                                            <label
                                                className='form__form-group-label'>ספק</label>
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                //disabled={!(this.props.userData.data.isManager || this.props.userData.data.isAdmin)}
                                                rtl={true}
                                                name='select'
                                                value={this.state.formFields.providerId}
                                                type={"select"}
                                                select
                                                options={allProviders}
                                                onChange={(event) => {
                                                    this.changeProvider(event.value)
                                                }}>
                                            </Select>
                                        </Col>
                                    </Row>}
                                    {this.state.showChangeStore &&
                                    <Row style={{flexDirection: "row-reverse"}}>
                                        <Col md={2} xs={12}>
                                            <label
                                                className='form__form-group-label'>חנות</label>
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                //disabled={!(this.props.userData.data.isManager || this.props.userData.data.isAdmin)}
                                                rtl={true}
                                                name='select'
                                                value={this.state.formFields.storeId}
                                                type={"select"}
                                                select
                                                options={stores}
                                                onChange={(event) => {
                                                    this.changeStore(event.value)
                                                }}>
                                            </Select>
                                        </Col>
                                    </Row>}
                                </div>
                            </div>}
                        </div>
                    </div>

                    {this.state.formFields.dealType === 1 && <div className="form__form-group">
                        {isKosher && <h1 style={{textAlign: 'center'}}>{this.getKasherText()}</h1>}
                        {likeKosher &&
                        <h1 style={{textAlign: 'center'}}>{this.getHotRegularText()}</h1>}
                        {this.state.formFields.lines.map((line, index) => {
                            return <Row style={{flexDirection: "row-reverse"}} key={index}>
                                {(!isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin)) &&
                                <Col sm={6} lg={2} md={2}>
                                    <div className={"cellular-div"}>
                                        <span
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.givenNumberQuestion}</span>
                                        <div className='form__form-group-field'>
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                name='select'
                                                value={line.question}
                                                type={"select"}
                                                select
                                                options={transferQuestionOptions}
                                                onChange={(value) => this.linesChanged("update", index, "question", value.value)}>
                                            </Select>

                                        </div>
                                    </div>
                                </Col>}

                                {isNew &&
                                <Col sm={6} lg={2} md={2}>
                                    <div className={"cellular-div"}>
                                        <span
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.givenNumberQuestionOnAdd}</span>
                                        <div className='form__form-group-field'>
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                name='select'
                                                value={line.isNewNumber}
                                                type={"select"}
                                                select
                                                options={transferQuestionOptionsOnAdd}
                                                onChange={(value) => this.linesChanged("update", index, "isNewNumber", value.value)}>
                                            </Select>
                                        </div>
                                    </div>
                                </Col>}

                                <Col sm={6} lg={2} md={2}>
                                    <div className={"cellular-div"}>
                                                                <span className="form__form-group-label">
                                                                    {TextManager.getCurrentTextResource().Sales.salesItem.customerNumber}
                                                                </span>
                                        <input
                                            value={line.customerNumber}
                                            style={line.isNewNumber === 0 ? {
                                                    backgroundColor: '#DCDCDC',
                                                    width: '100%'
                                                } :
                                                {backgroundColor: '#F0F8FF', width: '100%'}}
                                            name="customerNumber"
                                            dir={"auto"}
                                            type="text"
                                            disabled={((!isNew && line.isNewNumber === 0 && isStore) || (isNew && line.isNewNumber === 0))}
                                            onChange={(event) =>
                                                this.linesChanged("update", index, "customerNumber", event.target.value)}
                                        />
                                    </div>
                                </Col>

                                <Col sm={6} lg={3} md={3}>
                                    <div className={"cellular-div"}>
                                                            <span className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Sales.salesItem.simNumber}
                                                            </span>
                                        <input
                                            value={line.simNumber}
                                            dir={"auto"}
                                            style={{backgroundColor: '#F0F8FF', width: '100%'}}
                                            name="simNumber"
                                            type="text"
                                            onChange={(event) =>
                                                this.linesChanged("update", index, "simNumber", event.target.value)}/>
                                    </div>
                                </Col>
                                <Col sm={6} lg={3} md={3}>
                                    <div className={"cellular-div"}>
                                        <span
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Sales.salesItem.deal}</span>
                                        <div className='form__form-group-field'>
                                            {(isNew || (!isNew && (this.props.userData.data.isManager ||
                                                this.props.userData.data.isAdmin || this.state.wasProviderChanged))) &&
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                name='select'
                                                value={line.deal.text}
                                                type={"select"}
                                                select
                                                options={this.props.dealsList.map(d => {
                                                    return {
                                                        label: d.text,
                                                        value: d.text,
                                                        amount: d.amount,
                                                        tashvuId: d.tashvuId,
                                                        autoId: d.autoId
                                                    }
                                                })}
                                                onChange={(value) => this.dealChanged(index, value)}>
                                            </Select>}

                                            {/*(isNew || (!isNew && (this.props.userData.data.isManager ||
                                                this.props.userData.data.isAdmin || this.state.wasProviderChanged))) &&
                                            <Popover
                                                placement="bottom"
                                                isOpen={this.state.popoverOpen === index}
                                                target={"PopoverTop"+index}
                                                toggle={() => this.togglePopover(-1)}
                                            >
                                                <PopoverHeader className='bold-text'>:לידיעה המסלול כולל</PopoverHeader>
                                                <PopoverBody>
                                                <Textarea
                                                    disabled
                                                    value={line.deal.comment}
                                                    name="PopoverTop_comment"
                                                    onChange={(event) =>
                                                        this.props.dispatch(provider_deal_changed('comment', event.target.value, index))}
                                                />
                                                </PopoverBody>
                                                <p onClick={() => this.togglePopover(-1)}
                                                   style={{fontWeight: 'bold', color: '#1ABB10', textDecoration: 'underline', cursor: 'pointer',
                                                       margin: 0, textAlign: 'right', paddingRight: '10px'}}> ✔️הבנתי
                                                </p>
                                            </Popover>*/}

                                            {!isNew && !this.props.userData.data.isManager && !this.props.userData.data.isAdmin &&
                                            !this.state.wasProviderChanged &&
                                            <input
                                                value={line.deal.text}
                                                dir={"auto"}
                                                name="amount"
                                                type="text"
                                                disabled={true}
                                                style={{
                                                    backgroundColor: '#DCDCDC',
                                                    width: '100%'
                                                }}/>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={6} lg={2} md={2}>
                                    <div className={"cellular-div"}>
                                        <span
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.price}
                                        </span>
                                        <div className='form__form-group-field'>
                                            <input
                                                value={line.deal.amount}
                                                dir={"auto"}
                                                name="amount"
                                                type="text"
                                                disabled={true}
                                                style={{
                                                    backgroundColor: '#DCDCDC',
                                                    width: '100%'
                                                }}/>
                                        </div>
                                    </div>
                                </Col>

                                <Col sm={6} lg={2} md={2}>
                                    <div className={"cellular-div"}>
                                        <span className="form__form-group-label">
                                            ייחודי ID
                                        </span>
                                        <div className="form__form-group-field">
                                            <input name="customerName"
                                                   style={{backgroundColor: '#F0F8FF'}}
                                                   value={this.state.formFields.uniqueId}
                                                   dir={"auto"}
                                                   onChange={(event) =>
                                                       this.formFieldValueChanged('uniqueId', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Col>

                                {isNew && index > 0 && <Col sm={6} lg={1} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end"
                                }}>
                                    <div style={{padding: "20px 10px"}}>
                                        <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                           onClick={
                                               (event) =>
                                                   this.linesChanged("delete", index)
                                           }> </i>
                                    </div>
                                </Col>
                                }
                                {isNew && index === 0 && <Col sm={6} lg={1} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end"
                                }}>
                                    <div style={{padding: "20px 10px"}}
                                         className={"cellular-div"}>

                                    </div>
                                </Col>
                                }

                                {!isNew && <Col sm={6} lg={2} md={2}>
                                    <div className={"cellular-div"}>
                                                                <span
                                                                    className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.status}
                                                                </span>
                                        <div className='form__form-group-field'>
                                            <Button
                                                color={this.getLineStatusColor(line.status)}
                                                size='sm'
                                                style={{
                                                    marginRight: '-10px',
                                                    fontSize: '12px',
                                                }}
                                                onClick={() => this.changeLineStatus('status', index)}>{this.getLineStatusText(line.status)}</Button>
                                        </div>
                                    </div>
                                </Col>}

                                {isNew && <Col></Col>}

                                {isNew && <Col></Col>}

                                {!isNew && index > 0 && <Col sm={6} lg={1} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end"
                                }}>
                                    <div style={{padding: "20px 10px"}}
                                         className={"cellular-div"}>
                                        <i className="fas fa-trash" style={{cursor: 'pointer'}}
                                           onClick={
                                               (event) =>
                                                   this.linesChanged("delete", index)
                                           }> </i>
                                    </div>
                                </Col>
                                }
                            </Row>
                        })}
                        {isNew && <div style={{textAlign: 'right', marginTop: '10px'}}>
                            <Button color="primary"
                                    onClick={this.addLine}>{TextManager.getCurrentTextResource().Sales.salesItem.addLine}</Button>
                        </div>}
                        <Row style={{flexDirection: "row-reverse"}}>
                            <Col lg={3} md={6} xs={12}>
                                <div>
                                    <label className="form__form-group-label">
                                        יצירת קשר (ספרות בלבד)
                                    </label>
                                    <div className='form__form-group-field'
                                         style={{maxWidth: "none"}}>
                                        <NumberFormat
                                            value={this.state.formFields.contact}
                                            allowLeadingZeros={true}
                                            style={{backgroundColor: '#F0F8FF',}}
                                            name="contact"
                                            dir={"auto"}
                                            onChange={(event) =>
                                                this.formFieldValueChanged('contact', event.target.value)}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={6} xs={12}>
                                <div>
                                    <label className="form__form-group-label">
                                        מייל
                                    </label>
                                    <div className='form__form-group-field'
                                         style={{maxWidth: "none"}}>
                                        <input
                                            value={this.state.formFields.mail}
                                            type="text"
                                            style={{backgroundColor: '#F0F8FF',}}
                                            name="mail"
                                            dir={"auto"}
                                            onChange={(event) =>
                                                this.formFieldValueChanged('mail', event.target.value)}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>}

                    <div className="form__form-group">
                        <div className="form__form-group-field" style={{flexDirection: "column"}}>

                            {!isNew && this.state.formFields.lines && this.state.formFields.lines.length > 0 &&
                            (this.props.userData.data.isManager || this.props.userData.data.isAdmin) &&
                            <Row style={{flexDirection: "row-reverse"}}>
                                <Col lg={3} md={6} xs={12}>
                                    <div>
                                        <label className="form__form-group-label">
                                            שם משווק:
                                        </label>
                                        <div className='form__form-group-field'
                                             style={{maxWidth: "none"}}>
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                rtl={true}
                                                name='select'
                                                value={this.state.formFields.lines[0].handleName}
                                                type={"select"}
                                                select
                                                options={handleName}
                                                onChange={(event) =>
                                                    this.linesChanged("update", 0, "handleName", event.value)}/>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3} md={6} xs={12}>
                                    <div>
                                        <label className="form__form-group-label">
                                            שם משווק ישן:
                                        </label>
                                        <div className='form__form-group-field'
                                             style={{maxWidth: "none"}}>
                                            <input
                                                value={this.state.formFields.lines[0].notes}
                                                type="text"
                                                style={{backgroundColor: '#DCDCDC',}}
                                                name="customerNumber"
                                                dir={"auto"}
                                                disabled
                                                onChange={(event) =>
                                                    this.linesChanged("update", 0, "notes", event.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>}

                            {isStoreHandleName && <Row style={{flexDirection: "row-reverse"}}>
                                <Col lg={3} md={6} xs={12}>
                                    <div>
                                        <label className="form__form-group-label">
                                            שם משווק:
                                        </label>
                                        <div className='form__form-group-field'
                                             style={{maxWidth: "none"}}>
                                            <Select
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F0F8FF',
                                                    width: '100%'
                                                }}
                                                rtl={true}
                                                name='select'
                                                value={this.state.formFields.lines[0].handleName}
                                                type={"select"}
                                                select
                                                options={handleName}
                                                onChange={(event) =>
                                                    this.linesChanged("update", 0, "handleName", event.value)}/>
                                        </div>
                                    </div>
                                </Col>
                            </Row>}

                            {isNew && (this.props.userData.data.isManager || this.props.userData.data.isAdmin) &&
                            <Row style={{flexDirection: "row-reverse"}}>

                                <Col lg={3} md={6} xs={12}>
                                    <label className="form__form-group-label">
                                        שם חנות
                                    </label>
                                    <div className="form__form-group-field">
                                        <Select
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#F0F8FF',
                                                width: '100%'
                                            }}
                                            rtl={true}
                                            name='select'
                                            value={this.state.formFields.storeId}
                                            type={"select"}
                                            select
                                            options={stores}
                                            onChange={(event) => {
                                                let updatedFormFields = {...this.state.formFields};
                                                updatedFormFields.storeId = event.value;
                                                this.setState({formFields: updatedFormFields});
                                            }}>
                                        </Select>
                                    </div>
                                </Col>
                            </Row>}

                            <Row style={{flexDirection: "row-reverse"}}>

                                <Col lg={3} md={6} xs={12}>
                                    <label className="form__form-group-label">
                                        {TextManager.getCurrentTextResource().Sales.salesItem.customerNumberId}
                                    </label>
                                    <div className="form__form-group-field">
                                        <input name="customerName"
                                               style={{backgroundColor: '#F0F8FF'}}
                                               value={this.state.formFields.customerId}
                                               dir={"auto"}
                                               onChange={(event) =>
                                                   this.formFieldValueChanged('customerId', event.target.value)}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            {/* Only for Bezek */}
                            {providerId === 15 && <Row style={{flexDirection: "row-reverse"}}>

                                <Col lg={3} md={6} xs={12}>
                                    <label className="form__form-group-label">
                                        מספר מוקצה
                                    </label>
                                    <div className="form__form-group-field">
                                        <input name="customerName"
                                               style={{backgroundColor: '#F0F8FF'}}
                                               value={this.state.formFields.given_number}
                                               dir={"auto"}
                                               onChange={(event) =>
                                                   this.formFieldValueChanged('given_number', event.target.value)}
                                        />
                                    </div>
                                </Col>
                            </Row>}

                            {this.props.userData.data.isAdmin &&
                            <Row style={{flexDirection: "row-reverse"}}>
                                <Col lg={3} md={6} xs={12}>
                                    <div className="form__form-group" dir="rtl">
                                        <span className="form__form-group-label"
                                            style={{fontWeight: 'bold'}}>הערות אישיות לדנה</span>
                                        <div>
                                            <textarea
                                                style={{backgroundColor: '#F0F8FF'}}
                                                value={this.state.formFields.admin_comment}
                                                name="admin_comment"
                                                onChange={(event) =>
                                                    this.formFieldValueChanged('admin_comment', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>}
                        </div>
                    </div>

                    {isNew &&
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Row>
                                <Col sm={12}>
                                    <CheckBox
                                        name='selfDeal'
                                        label='הוקם עצמאית במערכת'
                                        value={this.state.selfDeal}
                                        onChange={(e) => this.setState({selfDeal: e})}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                    }

                    <div className="form__form-group">
                                            <span
                                                className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.paymentMethod}</span>
                        <div className={"radio-button__group"}>
                            <RadioButtonField name="credit" value={"credit"}
                                              label={TextManager.getCurrentTextResource().Sales.salesItem.creditCard}
                                              onChange={(value) => {
                                                  this.formFieldValueChanged('paymentMethod', 'credit');
                                              }}
                                              radioValue={this.state.formFields.paymentMethod}/>
                            <RadioButtonField name="bank" value={"bank"}
                                              onChange={(value) => {
                                                  this.formFieldValueChanged('paymentMethod', 'bank');

                                              }}
                                              label={TextManager.getCurrentTextResource().Sales.salesItem.directDebit}
                                              radioValue={this.state.formFields.paymentMethod}/>
                        </div>

                    </div>

                    {this.state.formFields.paymentMethod === "credit" &&
                    <div className="form__form-group">
                        {isDirect && <Row style={{flexDirection: 'row-reverse'}}>
                            <Alert color='warning' className='alert--bordered' icon>
                                <p><span className='bold-text'>שים לב ❤️ זה כרטיס דיירקט</span></p>
                            </Alert>
                        </Row>}
                        <Row style={{flexDirection: 'row-reverse'}}>

                            <Col sm={4}>
                                                    <span
                                                        className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cardNumber}</span>
                                <div className="form__form-group-field" style={this.state.cardValidWarning === '' ? {} : {border: '2px solid red'}}>
                                    <NumberFormat
                                        //format="#### #### #### ####"
                                        format="################"
                                        style={{backgroundColor: '#F0F8FF'}}
                                        //value={this.state.formFields.paymentDetails.cardNumber || ''}
                                        value={cardNumber}
                                        name="cardNumber"
                                        onFocus={() => this.cardFocusChanged("cardNumber")}
                                        placeholder="0000 0000 0000 0000"
                                        type="text"
                                        onChange={(event) => {
                                            this.paymentDetailsChanged('cardNumber', event.target.value);
                                        }
                                        }
                                    />
                                </div>
                                {this.state.cardValidWarning !== '' && <span style={{fontWeight: 'bold', color: 'red'}}
                                    className="form__form-group-label">{this.state.cardValidWarning}</span>}
                                <span
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.validationDate}</span>
                                <div className="form__form-group-field">
                                    <NumberFormat
                                        format={this.cardExpiry}
                                        style={{backgroundColor: '#F0F8FF'}}
                                        value={this.state.formFields.paymentDetails.validationDate || ""}
                                        name="validationDate"
                                        required
                                        onFocus={() => this.cardFocusChanged("validationDate")}
                                        placeholder="MM/YY"
                                        data-valid-example="05/18"
                                        onChange={(event) =>
                                            this.paymentDetailsChanged('validationDate', event.target.value)}
                                    />
                                </div>
                                <span
                                    className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.cvv}</span>
                                <div className="form__form-group-field">
                                    <input
                                        dir={"auto"}
                                        //value={this.state.formFields.paymentDetails.cvv || ''}
                                        value={cvv}
                                        style={{backgroundColor: '#F0F8FF'}}
                                        name="cvv"
                                        minLength={(this.state.formFields.paymentDetails.cardType === "mastercard"
                                            || this.state.formFields.paymentDetails.cardType === "visa") ? 3 : 4}
                                        maxLength={this.state.formFields.paymentDetails.cardType === "mastercard"
                                        || this.state.formFields.paymentDetails.cardType === "visa" ? 3 : 4}
                                        type="text"
                                        autoComplete={"on"}
                                        required
                                        onFocus={() => this.cardFocusChanged("cvv")}
                                        onChange={(event) =>
                                            this.paymentDetailsChanged('cvv', event.target.value)}
                                    />
                                </div>
                            </Col>

                            <Col sm={3}>
                                <div className="form__form-group-field">
                                    <Cards style={{margin: 'none'}}
                                           preview={true}
                                        //number={this.state.formFields.paymentDetails.cardNumber}
                                           number={cardNumber}
                                           name={""}
                                           expiry={this.state.formFields.paymentDetails.validationDate || ""}
                                        //cvc={this.state.formFields.paymentDetails.cvv}
                                           cvc={cvv}
                                           focused={this.state.cardFocus}
                                           placeholders={{
                                               name: ''
                                           }}
                                           callback={(event, isValid) =>
                                               this.paymentDetailsChanged('cardType', event.issuer)}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    }


                    {this.state.formFields.paymentMethod === "bank" &&
                    <div className="form__form-group">
                                            <span
                                                className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bank}</span>
                        <div className="form__form-group-field">
                            <input
                                dir={"auto"}

                                value={this.state.formFields.paymentDetails.bank}
                                name="bank"
                                type="text"
                                onChange={(event) =>
                                    this.paymentDetailsChanged('bank', event.target.value)}
                            />
                        </div>

                        <span
                            className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bankAccountBranch}</span>
                        <div className="form__form-group-field">
                            <input
                                dir={"auto"}

                                value={this.state.formFields.paymentDetails.bankAccountBranch}
                                name="bank"
                                type="text"
                                onChange={(event) =>
                                    this.paymentDetailsChanged('bankAccountBranch', event.target.value)}
                            />
                        </div>

                        <span
                            className="form__form-group-label">{TextManager.getCurrentTextResource().Sales.salesItem.bankAccountNumber}</span>
                        <div className="form__form-group-field">
                            <input
                                dir={"auto"}
                                value={this.state.formFields.paymentDetails.bankAccountNumber}
                                name="bank"
                                type="text"
                                onChange={(event) =>
                                    this.paymentDetailsChanged('bankAccountNumber', event.target.value)}
                            />
                        </div>

                    </div>
                    }
                </Col>
                <Col md={6}>
                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                         src={environment.getServerBasePath() + '/api/deal_image/download?dealID=' + this.state.formFields.deal_image} alt="catalog-item-img" />
                </Col>
            </Row>
        )
    };

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    saveEsimData = (phone, email) => {

        let data = {phone_number: phone, email: email};

        this.formFieldValueChanged('eSimDetail', data);
    };

    saveHotAutoData = (phone, phone1, payment, cityName, streetName, houseNum,
                       customerNumber, email, customerName) => {
        let data = {is_auto: true, tel_num: phone, payment: payment};

        this.formFieldValueChanged('hotAutoDetail', data);
        this.formFieldValueChanged('city', undefined, cityName);
        this.formFieldValueChanged('street', undefined, streetName);
        this.formFieldValueChanged('number', houseNum);
        this.formFieldValueChanged('flat', "1");
        this.formFieldValueChanged('contact', phone1);
        this.formFieldValueChanged('customerId', customerNumber);
        this.formFieldValueChanged('mail', email);
        this.formFieldValueChanged('customerName', customerName);

        this.paymentDetailsChanged('cvv', '***');
        this.paymentDetailsChanged('validationDate', '**/**');
        this.paymentDetailsChanged('cardNumber', payment);
    };


    render() {

        document.querySelectorAll(".rccs__number").forEach(function (anchor) {
            anchor.innerHTML = anchor.innerHTML.replace(/•/g, ' ');
        });

        let providerId = this.getProviderId();
        let logoUrl = environment.getServerBasePath() + '/providers/download?providerID=' + providerId;

        let isNew = this.props.location.state && this.props.location.state.name;

        //console.log(this.props.customer.id);

        if (this.state.saved === true) {
            if (isNew) {
                return <Redirect to='/sales'/>
            }
        }
        let totalPrice = 0;
        if (this.state.formFields.lines) {
            this.state.formFields.lines.forEach((line) => {
                totalPrice += parseInt(line.deal.amount);
            });
        }

        let transferQuestionOptions = [
            /*{
                value: 0,
                label: "לא"
            },
            {
                value: 1,
                label: "כן"
            }*/
            {
                value: 0,
                label: "אין"
            },
            {
                value: 1,
                label: "יש"
            }
        ];

        let transferQuestionOptionsOnAdd = [
            {
                value: 0,
                label: "חדש"
            },
            {
                value: 1,
                label: "ניוד"
            }
        ];

        let dealsStatusTypes = [];
        if (this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.dealsStatus) {
            dealsStatusTypes = this.props.utilsData.data.dealsStatus.map(a => {
                return {
                    value: a.value,
                    label: environment.DealsTypesHe.find(b => b.id === a.value).name
                }
            });
        }

        let lastUpdateBy = {id: 0, name: ''};
        let managers = [];
        if (this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.managers) {
            //managers = this.props.utilsData.data.managers.filter(a => a.managerType === (this.state.formFields.dealType === 1 ? 2 : 4)).map(a => {
            managers = this.props.utilsData.data.managers.filter(a => a.managerType === this.props.userData.data.userType).map(a => {
                return {
                    value: a.id,
                    label: a.name
                }
            });

            if (this.props.userData.data.isManager) {
                managers = managers.filter(a => (a.value === this.props.userData.data.id || a.value === this.state.formFields.careBy));
            }

            lastUpdateBy = this.props.utilsData.data.managers.find(a => a.id === this.state.formFields.lastUpdateBy);

            if (lastUpdateBy === undefined) lastUpdateBy = {id: 0, name: ''};
        }

        let isStore = false;
        let isManager = false;
        let isAdmin = false;
        let isStoreHandleName = false;

        if (this.props.userData && this.props.userData.data) {
            if (this.props.userData.data.isManager) {
                isManager = true;
            }

            if (this.props.userData.data.isAdmin) {
                isAdmin = true;
            }

            if (!this.props.userData.data.isAdmin && !this.props.userData.data.isManager) {
                isStore = true;

                if (this.props.userData.data.handleName !== undefined && this.props.userData.data.handleName !== '') {
                    isStoreHandleName = true;
                }
            }
        }

        let handleName = [];
        if (this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.handleName) {

            if (!isStore) {
                handleName = this.props.utilsData.data.handleName;
            } else {
                if (isStoreHandleName) {
                    handleName = this.props.utilsData.data.handleName.filter(a => this.props.userData.data.handleName.includes(a.value.toString()));
                }
            }
        }

        let provider = {};
        if (this.props.sales) {
            provider = this.props.sales.filter(a => a.id === this.getProviderId())[0];
        }

        let allProviders = [];
        if (this.props.sales && this.state.showChangeProvider) {
            //allProviders = this.props.sales.filter(a => a.providerType === parseInt(this.state.formFields.dealType)).map(d => {return {
            allProviders = this.props.sales.filter(this.filterProviders).map(d => {
                return {
                    label: d.name,
                    value: d.id
                }
            });
        }

        let stores = [];
        if (this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.stores) {
            stores = this.props.utilsData.data.stores;
        }


        let alreadyInEditText = "";
        if (this.state.now_handle_by > 0) {
            let tmp = stores.find(e => e.value === this.state.now_handle_by);

            if (tmp === undefined) {
                if (this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.managers) {
                    tmp = this.props.utilsData.data.managers.find(e => e.id === this.state.now_handle_by);
                }

                if (tmp === undefined) {
                    tmp = "Admin";
                } else {
                    tmp = tmp.name;
                }
            } else {
                tmp = tmp.label;
            }

            alreadyInEditText = "העסקה בביצוע כרגע על ידי " + tmp;
        }

        let isKosher = false;
        if (((this.props.userData && this.props.userData.data && this.props.userData.data.isManager && (this.props.userData.data.id !== 118 && this.props.userData.data.id !== 138))
            || (this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin)) &&
            !isNew && providerId === 20) { // Hot Kosher

            isKosher = true;
        }

        let likeKosher = false;
        if (
            (
                (this.props.userData && this.props.userData.data && this.props.userData.data.isManager && (this.props.userData.data.id !== 138)) ||
                (this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin)
            ) &&
            (this.state.formFields.storeId === 132 || this.state.formFields.storeId === 167 ||
                this.state.formFields.storeId === 120 || this.state.formFields.storeId === 121 || this.state.formFields.storeId === 122
            ) &&
            !isNew && providerId === 1) { // Hot Regular

            likeKosher = true;
        }

        let isDirect = this.isDirectCard();

        let cardNumber = this.getCardNumber();

        let cvv = this.getCvv();

        if (isNew && this.state.formFields.id.length === 9 && this.state.isImport) {
            this.checkImport();
            this.setState({isImport: false});
        }

        if (isNew && (providerId === 1 || providerId === 20 || providerId === 5) && this.state.formFields.id.length === 9 && this.state.isCheckHot) {
            this.checkHotCustomer();
            this.setState({isCheckHot: false});
        }

        /* New deals for TV and Internet*/
        // TV
        let tvDeals_1 = [];
        let tvDeals_2 = [];
        let tvDeals_3 = [];

        let tvDealOption = [];

        if (this.state.formFields.dealType === 2) {
            let tmp = this.props.dealsList.filter(a => a.amount === "1");
            if (tmp !== undefined) tvDeals_1 = tmp;

            tmp = this.props.dealsList.filter(a => a.amount === "2");
            if (tmp !== undefined) tvDeals_2 = tmp;

            tmp = this.props.dealsList.filter(a => a.amount === "3");
            if (tmp !== undefined) tvDeals_3 = tmp;

            if (this.state.tvInternetDealType === 0) tvDealOption = tvDeals_1;
            else if (this.state.tvInternetDealType === 1) tvDealOption = tvDeals_2;
            else if (this.state.tvInternetDealType === 2) tvDealOption = tvDeals_3;

            if (!isNew && this.state.tvInternetDealType === -1 && this.state.formFields.dealType === 2) {
                if (tvDeals_1 !== undefined && tvDeals_2 !== undefined && tvDeals_3 !== undefined) {

                    // 1
                    let res = tvDeals_1.find(b => b.text === this.state.formFields.tv.deal);
                    if (res !== undefined)
                        this.setState({tvInternetDealType: 0});

                    // 2
                    res = tvDeals_2.find(b => b.text === this.state.formFields.tv.deal);
                    if (res !== undefined)
                        this.setState({tvInternetDealType: 1});

                    // 3
                    res = tvDeals_3.find(b => b.text === this.state.formFields.tv.deal);
                    if (res !== undefined)
                        this.setState({tvInternetDealType: 2});
                }
            }
        }

        // Internet
        let internetDeals_1 = [];
        let internetDeals_2 = [];
        let internetDeals_3 = [];
        let internetDeals_4 = [];
        let internetDeals_5 = [];

        let internetDealOption = [];
        let bezekHotRestOption = [];

        if (this.state.formFields.dealType === 3) {

            if (providerId === 15) bezekHotRestOption = bezekField;
            else if (providerId === 16) bezekHotRestOption = hotField;
            else bezekHotRestOption = allRestField;

            let tmp = this.props.dealsList.filter(a => a.amount === "1");
            if (tmp !== undefined) internetDeals_1 = tmp;

            tmp = this.props.dealsList.filter(a => a.amount === "2");
            if (tmp !== undefined) internetDeals_2 = tmp;

            tmp = this.props.dealsList.filter(a => a.amount === "3");
            if (tmp !== undefined) internetDeals_3 = tmp;

            if (providerId === 15 || providerId === 16) {
                tmp = this.props.dealsList.filter(a => a.amount === "4");
                if (tmp !== undefined) internetDeals_4 = tmp;
            }

            if (providerId === 15) {
                tmp = this.props.dealsList.filter(a => a.amount === "5");
                if (tmp !== undefined) internetDeals_5 = tmp;
            }

            if (this.state.tvInternetDealType === 0) internetDealOption = internetDeals_1;
            else if (this.state.tvInternetDealType === 1) internetDealOption = internetDeals_2;
            else if (this.state.tvInternetDealType === 2) internetDealOption = internetDeals_3;
            else if (this.state.tvInternetDealType === 3 && (providerId === 15 || providerId === 16)) internetDealOption = internetDeals_4;
            else if (this.state.tvInternetDealType === 4 && providerId === 15) internetDealOption = internetDeals_5;

            if (!isNew && this.state.tvInternetDealType === -1 && this.state.formFields.dealType === 3) {
                if (internetDeals_1 !== undefined && internetDeals_2 !== undefined && internetDeals_3 !== undefined) {

                    // 1
                    let res = internetDeals_1.find(b => b.text === this.state.formFields.internet.deal);
                    if (res !== undefined)
                        this.setState({tvInternetDealType: 0});

                    // 2
                    res = internetDeals_2.find(b => b.text === this.state.formFields.internet.deal);
                    if (res !== undefined)
                        this.setState({tvInternetDealType: 1});

                    // 3
                    res = internetDeals_3.find(b => b.text === this.state.formFields.internet.deal);
                    if (res !== undefined)
                        this.setState({tvInternetDealType: 2});

                    // 4
                    if ((providerId === 15 || providerId === 16) && internetDeals_4 !== undefined) {
                        res = internetDeals_4.find(b => b.text === this.state.formFields.internet.deal);
                        if (res !== undefined)
                            this.setState({tvInternetDealType: 3});
                    }

                    // 5
                    if (providerId === 15 && internetDeals_5 !== undefined) {
                        res = internetDeals_5.find(b => b.text === this.state.formFields.internet.deal);
                        if (res !== undefined)
                            this.setState({tvInternetDealType: 4});
                    }
                }
            }
        }

        let showSpecailWarning = false;
        let meshavekName = "";

        if (this.props.userData && this.props.userData.data) {
            if (environment.ListManagersFeatures.includes(this.props.userData.data.id) ||isAdmin) {
                // Partner
                if (providerId === 7) {
                    let line = this.state.formFields.lines.filter(e => e.deal.text.includes("100"));

                    if (line !== undefined && line.length > 0 && line[0].isNewNumber === 0) {
                        showSpecailWarning = true;
                        meshavekName = "להקים על משווק סגרון בלבד";
                    }
                } else if (providerId === 1) {
                    let line = this.state.formFields.lines.filter(e => e.deal.text.includes("150"));

                    if (line !== undefined && line.length > 0 && line[0].isNewNumber === 0) {
                        showSpecailWarning = true;
                        meshavekName = "להקים על משווק גולדפון בלבד";
                    }

                    line = this.state.formFields.lines.filter(e => e.deal.text.includes("100"));

                    if (line !== undefined && line.length > 0 && line[0].isNewNumber === 0) {
                        showSpecailWarning = true;
                        meshavekName = "להקים על משווק גולדפון בלבד";
                    }
                } else if (providerId === 3) {
                    let line = this.state.formFields.lines.filter(e => e.deal.text.includes("150"));

                    if (line !== undefined && line.length > 0) {
                        showSpecailWarning = true;
                        meshavekName = "להקים על משווק סגרון בלבד";
                    }
                }
            }
        }

        let isCellcom = false;
        if (providerId === 6 || providerId === 27) {
            isCellcom = true;
        }

        let isPelephon = false;
        if (providerId === 9 || providerId === 25) {
            isPelephon = true;
        }

        let isGolan = false;
        if (providerId === 4 || providerId === 28) {
            isGolan = true;
        }

        let isHot = false;
        if (providerId === 1 || providerId === 20) {
            isHot = true;
        }


        let isFromList = false;

        if (this.props.userData && this.props.userData.data) {
            if (environment.ListManagersFeatures.includes(this.props.userData.data.id) || isAdmin)
                isFromList = true;
        }

        let isSendTashvu = false;
        if (this.props.userData && this.props.userData.data) {
            if (environment.ListManagersFeatures.includes(this.props.userData.data.id) || isAdmin)
                isSendTashvu = true;
        }

        let isImage = this.state.formFields.deal_image !== 0;

        let isAuto = this.state.formFields.isAuto.length !== 0;

        //console.log(this.state.formFields.hotAutoDetail);

        return (
            <Container className='sales'>
                {this.state.success &&
                <ModalTrue color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                           message={TextManager.getCurrentTextResource().Text.dealSucceeded}
                           approve={() => this.setState({saved: true})}/>
                }
                <style>
                    {`
                        .card-body {
                        box-shadow: 0 10px 30px 1px rgba(0, 0, 0, 0.06);
                        }
                    `}
                </style>

                {(this.props.status === 'request' || this.state.saving) &&
                <Row>
                    <LoadingProgress/>
                </Row>}

                {(this.props.status === 'error' || this.state.error) &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{this.state.errorText !== "" ? this.state.errorText : TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>}

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>}

                {(this.state.now_handle_by > 0 && this.state.now_handle_by !== this.props.userData.data.id && !isStore) &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>עסקה באמצע תפעול כרגע</span></p>
                        <p>{alreadyInEditText}</p>
                    </Alert>
                </Row>
                }

                {isKosher &&
                <ModalTrue color='primary' title="!!!שימו לב" noCancel
                           message={" נא לאקטב לחנות הזו את העסקה על " + this.getKasherText()}/>
                }

                {likeKosher &&
                <ModalTrue color='primary' title="!!!שימו לב" noCancel
                           message={" נא לאקטב לחנות הזו את העסקה על " + this.getHotRegularText()}/>
                }

                {this.state.isPassportShow && <ModalTrue color='primary' title="!!!שימו לב" noCancel
                           message={" שים-לב שהמספר ת.ז שרשמת שייך לבעל כרטיס האשראי " } okText={"כן, בדקתי"}
                            approve={() => {this.setState({isPassportShow: false});}}/>
                }

                <ModalESim color='primary' title='eSim' header
                           data={this.state.formFields.eSimDetail}
                           isESimShow={this.state.isESimShow}
                           saveEsimData={this.saveEsimData}
                           toggle={() => {this.setState({isESimShow: !this.state.isESimShow})}}/>

                <ModalHotCustomer color='primary' title='' header
                           passport={this.state.formFields.id}
                           isHotCustomer={this.state.isHotCustomer}
                           saveHotAutoData={this.saveHotAutoData}
                           toggle={() => {this.setState({isHotCustomer: !this.state.isHotCustomer})}}/>

                {showSpecailWarning && this.state.popoverOpen === -1 && <ModalTrueBig color='primary' title="!!!שימו לב" noCancel
                                                     message={meshavekName}/>}

                {this.props.status === 'success' &&

                <Row>
                    {isNew && <Col md={12} lg={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3>{this.props.location.state.name}</h3>

                                <div className='topbar__right'>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>}

                    <Col md={12} lg={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                {this.state.warning !== '' &&
                                <Row>
                                    <Alert color='warning' className='alert--bordered' icon>
                                        <p><span
                                            className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                        </p>
                                    </Alert>
                                </Row>}

                                <form className="form">

                                    {isImage && <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                        <Row style={{flexDirection: "row-reverse"}}>
                                            <CheckBox
                                                name='showIamge'
                                                label='הצג תמונה'
                                                value={this.state.showImage}
                                                onChange={(e) => this.setState({showImage: e})}
                                            />
                                        </Row>
                                    </div>}

                                    {this.state.formFields.status === 1 && (isAdmin || environment.ListManagersFeatures.includes(this.props.userData.data.id)) &&
                                    (isCellcom || isPelephon || isGolan || isHot) &&
                                    <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                        <Row style={{flexDirection: "row-reverse"}}>
                                            <Button color='primary' size='sm' style={{
                                                whiteSpace: 'normal',
                                                fontSize: '12px',
                                                marginTop: '30px',
                                                marginRight: '15px'
                                        }}
                                            onClick={(e) => {
                                                this.sendToAuto()
                                            }}>
                                                Send Auto
                                            </Button>
                                        </Row>
                                    </div>}

                                    {!isNew && <div className='form__form-group'>
                                        <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                            <Row style={{flexDirection: "row-reverse"}}>

                                                <Col md={3} xs={12}>
                                                    <label
                                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.day}</label>
                                                    <div className='form__form-group-field'>
                                                        <input
                                                            value={this.state.formFields.is_duplicate === 0 ? this.state.formFields.day :
                                                                this.state.formFields.is_duplicate === 1 ? this.state.formFields.day + ' המקור ' : this.state.formFields.day + ' השכפול ' + (this.state.formFields.is_duplicate - 1)}
                                                            dir={"auto"}
                                                            name="amount"
                                                            type="text"
                                                            disabled={true}
                                                            style={{
                                                                backgroundColor: '#DCDCDC',
                                                                width: '200px'
                                                            }}/>
                                                    </div>
                                                </Col>

                                                <Col md={3} xs={12}>
                                                    <label
                                                        className='form__form-group-label'>נציג מטפל</label>
                                                    <Select
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: '#F0F8FF',
                                                            width: '100%'
                                                        }}
                                                        disabled={!(this.props.userData.data.isManager || this.props.userData.data.isAdmin)}
                                                        rtl={true}
                                                        name='select'
                                                        value={this.state.formFields.careBy}
                                                        type={"select"}
                                                        select
                                                        options={managers}
                                                        onChange={(event) => {
                                                            let updatedFormFields = {...this.state.formFields};
                                                            updatedFormFields.careBy = event.value;
                                                            this.setState({formFields: updatedFormFields});
                                                        }}>
                                                    </Select>
                                                </Col>

                                                {this.props.userData.data.isAdmin &&
                                                <Col md={3} xs={12}>
                                                    <label
                                                        className='form__form-group-label'>Last update by</label>
                                                    <div className='form__form-group-field'>
                                                        <input
                                                            value={lastUpdateBy.name}
                                                            dir={"auto"}
                                                            name="amount"
                                                            type="text"
                                                            disabled={true}
                                                            style={{
                                                                backgroundColor: '#DCDCDC',
                                                                width: '140px'
                                                            }}/>
                                                    </div>
                                                </Col>
                                                }
                                            </Row>
                                        </div>
                                    </div>
                                    }

                                    {/* Automation Result */}
                                    {isAuto && (isAdmin || environment.ListManagersFeatures.includes(this.props.userData.data.id)) && <div className='form__form-group'>
                                        <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                            <Row>
                                                <Col md={12}>
                                                    <Card>
                                                        <CardBody style={{direction: "rtl"}}>
                                                            <div className="card__title">
                                                                <h4 style={{textAlign: 'right'}}>{this.state.formFields.autoMes}</h4>
                                                            </div>

                                                            {this.state.formFields.autoDealDetail.map((deal, index) =>
                                                                <Col md={4}>
                                                                    <div className='form__form-group' key={index}>
                                                                        <label
                                                                            className='form__form-group-label'>{index + 1}</label>
                                                                        <div className='form__form-group-field'>
                                                                            <input
                                                                                dir={"auto"}
                                                                                value={deal.status}
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            )}

                                                            <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                                <Row>
                                                                    <Button color='primary' size='sm' style={{
                                                                        whiteSpace: 'normal',
                                                                        fontSize: '12px',
                                                                        marginRight: '30px'
                                                                    }}
                                                                            onClick={(e) => {this.setState({isShowAutoImages: !this.state.isShowAutoImages})}}>
                                                                        הצגת התמונות של אוטומציה
                                                                    </Button>
                                                                </Row>
                                                            </div>

                                                            {this.state.isShowAutoImages && <div className="tabs tabs--bordered-top">
                                                                <div className="tabs__wrap" style={{direction: 'rtl'}}>
                                                                    <Nav tabs>
                                                                        {
                                                                            this.state.formFields.isAuto.map((entry, index) => (
                                                                                <NavItem>
                                                                                    <NavLink
                                                                                        className={classnames({active: this.state.activeTab === index})}
                                                                                        onClick={() => {
                                                                                            this.toggle(index);
                                                                                        }}
                                                                                    >
                                                                                        {"Image: " + (index+1)}
                                                                                    </NavLink>
                                                                                </NavItem>
                                                                            ))
                                                                        }
                                                                    </Nav>
                                                                    <TabContent activeTab={this.state.activeTab}>
                                                                        {
                                                                            this.state.formFields.isAuto.map((entry, index) => (
                                                                                <TabPane tabId={index} style={{direction: 'ltr'}}>
                                                                                    <div className="catalog-item__img-wrap" style={{height: '100%'}}>
                                                                                        <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                                                             src={environment.getServerBasePath() + '/api_auto/deal_image/download?dealID=' + entry}
                                                                                             alt="catalog-item-img"/>
                                                                                    </div>
                                                                                </TabPane>
                                                                            ))
                                                                        }
                                                                    </TabContent>
                                                                </div>
                                                            </div>}
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>}

                                    {/* NO Image*/}
                                    {!isImage && this.getNoImagePart(isNew, logoUrl, provider, isManager,
                                        isAdmin, isSendTashvu, isCellcom,
                                        allProviders, stores, isKosher, likeKosher, transferQuestionOptions,
                                        transferQuestionOptionsOnAdd, isStore, tvDealOption, dealsStatusTypes,
                                        bezekHotRestOption, internetDealOption, handleName, isStoreHandleName,
                                        providerId, isDirect, cardNumber, cvv)}

                                    {/* YES Image and show it*/}
                                    {isFromList && this.state.showImage && isImage && this.getWithImagePart(isNew, logoUrl, provider, isManager,
                                        isAdmin, isSendTashvu, isCellcom,
                                        allProviders, stores, isKosher, likeKosher, transferQuestionOptions,
                                        transferQuestionOptionsOnAdd, isStore, tvDealOption, dealsStatusTypes,
                                        bezekHotRestOption, internetDealOption, handleName, isStoreHandleName,
                                        providerId, isDirect, cardNumber, cvv)}

                                    {/* YES Image but NOT show it*/}
                                    {isFromList && !this.state.showImage && isImage &&this.getNoImagePart(isNew, logoUrl, provider, isManager,
                                        isAdmin, isSendTashvu, isCellcom,
                                        allProviders, stores, isKosher, likeKosher, transferQuestionOptions,
                                        transferQuestionOptionsOnAdd, isStore, tvDealOption, dealsStatusTypes,
                                        bezekHotRestOption, internetDealOption, handleName, isStoreHandleName,
                                        providerId, isDirect, cardNumber, cvv)}


                                    <div className="form__form-group">
                                        {this.state.warning !== '' &&
                                        <Row>
                                            <Alert color='warning' className='alert--bordered' icon>
                                                <p><span
                                                    className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                                </p>
                                            </Alert>
                                        </Row>}
                                    </div>

                                    {((isFromList && (this.state.formFields.deal_reminder === 0 || this.state.formFields.deal_reminder === false)) || !isFromList) &&
                                    <div className="form__form-group">
                                        <Row style={{flexDirection: 'row-reverse'}}>
                                            <Col sm={8}>
                                                <div dir="rtl" style={{maxHeight: '300px'}}>
                                                    <ChatCard
                                                        type={1}
                                                        userId={isNew ? 0 : this.props.customer.id}
                                                        chat={this.state.formFields.chat}
                                                        currentUser={this.props.userData.data}
                                                        comment={this.state.comment}
                                                        deleteMessage={this.deleteMessage}
                                                        updateComment={this.updateComment}
                                                        background={'lightgrey'}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    }

                                    {isFromList && (this.state.formFields.deal_reminder === 1 || this.state.formFields.deal_reminder === true) &&
                                    <div className="form__form-group">
                                        <Row style={{flexDirection: 'row-reverse'}}>
                                            <Col sm={6}>
                                                <div dir="rtl">
                                                    <ChatCard
                                                        type={1}
                                                        userId={isNew ? 0 : this.props.customer.id}
                                                        chat={this.state.formFields.chat}
                                                        currentUser={this.props.userData.data}
                                                        comment={this.state.comment}
                                                        deleteMessage={this.deleteMessage}
                                                        updateComment={this.updateComment}
                                                        background={'lightgrey'}
                                                    />
                                                </div>
                                            </Col>

                                            <Col sm={6}>
                                                <div dir="rtl">
                                                    <ChatCard
                                                        type={2}
                                                        userId={isNew ? 0 : this.props.customer.id}
                                                        chat={this.state.formFields.chatDealReminder}
                                                        currentUser={this.props.userData.data}
                                                        commentD={this.state.commentD}
                                                        deleteMessage={this.deleteMessage}
                                                        updateComment={this.updateComment}
                                                        background={'lightgreen'}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>}

                                    <div className="form__form-group" style={{paddingTop: '2rem'}}></div>

                                    {(isManager || isAdmin) && (this.props.userData.data.id !== 548 && this.props.userData.data.id !== 683) &&
                                    <div className="form__form-group">
                                        <Row style={{flexDirection: 'row-reverse'}}>
                                            <Col sm={12}>
                                                <CheckBox
                                                    name='showPassword'
                                                    label='לעדכן כחדש'
                                                    value={this.state.formFields.as_new}
                                                    onChange={(e) => this.formFieldValueChanged('as_new', e)}
                                                />
                                            </Col>
                                            {isFromList && <Col sm={12}>
                                                <CheckBox
                                                    name='showPassword1'
                                                    label='לעדכן עם תזכורת'
                                                    value={this.state.formFields.deal_reminder}
                                                    onChange={(e) => this.formFieldValueChanged('deal_reminder', e)}
                                                />
                                            </Col>}
                                        </Row>
                                    </div>
                                    }


                                    <ButtonToolbar className="form__button-toolbar">
                                        <Button color="primary"
                                                onClick={this.saveCustomer}>{isNew ? TextManager.getCurrentTextResource().Sales.salesItem.send : TextManager.getCurrentTextResource().Sales.salesItem.update}</Button>
                                        {this.props.onClose && <Button type="button" onClick={() => {
                                            this.closeDeal();
                                            this.props.onClose();
                                        }}>
                                            {TextManager.getCurrentTextResource().Text.cancel}
                                        </Button>}

                                        {!this.props.onClose &&
                                        <Button type="button" onClick={this.closeDeal}>
                                            {TextManager.getCurrentTextResource().Text.cancel}

                                        </Button>}

                                        {(isManager || isAdmin) && <Button type="button" color="success"
                                                                           onClick={this.sendAsEnvelope}>
                                            שלח כמעטפה
                                        </Button>}
                                    </ButtonToolbar>
                                </form>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>}

            </Container>
        )


    }

}


const mapStateToProps = (state) => {
    return {
        dealsList: state.salesItem.dealsList,
        status: state.salesItem.status,
        userData: state.userData,
        utilsData: state.utilsData,
        sales: state.sales.data,
    };
};

export default withRouter(connect(mapStateToProps)(SalesItem))